{
	"__schema": {
		"queryType": {
			"name": "Query",
			"kind": "OBJECT"
		},
		"mutationType": {
			"name": "Mutation",
			"kind": "OBJECT"
		},
		"subscriptionType": {
			"name": "Subscription",
			"kind": "OBJECT"
		},
		"types": [
			{
				"kind": "OBJECT",
				"name": "Attribute",
				"fields": [
					{
						"name": "code",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "filterTitle",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "group",
						"type": {
							"kind": "OBJECT",
							"name": "AttributeGroup",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isRequired",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "options",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "AttributeOption",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "optionsOrder",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "pim",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributePim",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "prefix",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "showInCategoryFilter",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "showInProductListing",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "showInProductPage",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "suffix",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AttributeCreatePayload",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "AttributeCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "AttributeCreatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AttributeDeletePayload",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "AttributeDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "AttributeDeletePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AttributeGroup",
				"fields": [
					{
						"name": "attributeCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "attributes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Attribute",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": [
							{
								"name": "showInProductListing",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "showInProductPage",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AttributeGroupAddAttributesPayload",
				"fields": [
					{
						"name": "attributeGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "attributes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Attribute",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "AttributeGroupAddAttributesUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "AttributeGroupAddAttributesPayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AttributeGroupCreatePayload",
				"fields": [
					{
						"name": "attributeGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "AttributeGroupCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "AttributeGroupCreatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AttributeGroupDeletePayload",
				"fields": [
					{
						"name": "attributeGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "AttributeGroupDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "AttributeGroupDeletePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AttributeGroupRemoveAttributesPayload",
				"fields": [
					{
						"name": "attributeGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "attributes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Attribute",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "AttributeGroupRemoveAttributesUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "AttributeGroupRemoveAttributesPayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AttributeGroupReorderAttributesPayload",
				"fields": [
					{
						"name": "attributeGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "AttributeGroupReorderAttributesUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "AttributeGroupReorderAttributesPayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AttributeGroupReorderPayload",
				"fields": [
					{
						"name": "attributeGroups",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "AttributeGroup",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "AttributeGroupReorderUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "AttributeGroupReorderPayload"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "AttributeGroupResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "AttributeGroup"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AttributeGroupUpdatePayload",
				"fields": [
					{
						"name": "attributeGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "AttributeGroupUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "AttributeGroupUpdatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AttributeGroupsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "AttributeGroupsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "AttributeGroupsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "AttributeOption",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "color",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "image",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AttributeOptionCreatePayload",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "attributeOption",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeOption",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "AttributeOptionCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "AttributeOptionCreatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AttributeOptionDeletePayload",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "attributeOption",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeOption",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "AttributeOptionDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "AttributeOptionDeletePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "AttributeOptionResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "AttributeOption"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AttributeOptionUpdatePayload",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "attributeOption",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeOption",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "AttributeOptionUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "AttributeOptionUpdatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AttributeOptionsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "AttributeOptionsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "AttributeOptionsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeOption",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "AttributePim",
				"fields": [
					{
						"name": "allowUpdates",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "AttributeReorderOptionsPayload",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "AttributeReorderOptionsUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "AttributeReorderOptionsPayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "AttributeResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "Attribute"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AttributeUpdatePayload",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "AttributeUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "AttributeUpdatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AttributesConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "AttributesEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "AttributesEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "INTERFACE",
				"name": "Audit",
				"fields": [
					{
						"name": "action",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "diffs",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "AuditDiff",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "source",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "user",
						"type": {
							"kind": "OBJECT",
							"name": "User",
							"ofType": null
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				],
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "AuditCategory"
					},
					{
						"kind": "OBJECT",
						"name": "AuditCustomer"
					},
					{
						"kind": "OBJECT",
						"name": "AuditCustomerAddress"
					},
					{
						"kind": "OBJECT",
						"name": "AuditOrderAddress"
					},
					{
						"kind": "OBJECT",
						"name": "AuditOrderPayment"
					},
					{
						"kind": "OBJECT",
						"name": "AuditProduct"
					},
					{
						"kind": "OBJECT",
						"name": "AuditProductAsset"
					},
					{
						"kind": "OBJECT",
						"name": "AuditProductAttributeValue"
					},
					{
						"kind": "OBJECT",
						"name": "AuditProductMedia"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AuditBooleanDiff",
				"fields": [
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "newValue",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "oldValue",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "AuditDiff"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AuditCategory",
				"fields": [
					{
						"name": "action",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "category",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Category",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "diffs",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "AuditDiff",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "source",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "user",
						"type": {
							"kind": "OBJECT",
							"name": "User",
							"ofType": null
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Audit"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AuditCustomer",
				"fields": [
					{
						"name": "action",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "customer",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Customer",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "diffs",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "AuditDiff",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "source",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "user",
						"type": {
							"kind": "OBJECT",
							"name": "User",
							"ofType": null
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Audit"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AuditCustomerAddress",
				"fields": [
					{
						"name": "action",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "customer",
						"type": {
							"kind": "OBJECT",
							"name": "Customer",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "customerAddress",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CustomerAddress",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "diffs",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "AuditDiff",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "source",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "user",
						"type": {
							"kind": "OBJECT",
							"name": "User",
							"ofType": null
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Audit"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AuditDateDiff",
				"fields": [
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "newValue",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "oldValue",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "AuditDiff"
					}
				]
			},
			{
				"kind": "INTERFACE",
				"name": "AuditDiff",
				"fields": [
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [],
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "AuditBooleanDiff"
					},
					{
						"kind": "OBJECT",
						"name": "AuditDateDiff"
					},
					{
						"kind": "OBJECT",
						"name": "AuditEnumDiff"
					},
					{
						"kind": "OBJECT",
						"name": "AuditMoneyDiff"
					},
					{
						"kind": "OBJECT",
						"name": "AuditNumberArrayDiff"
					},
					{
						"kind": "OBJECT",
						"name": "AuditNumberDiff"
					},
					{
						"kind": "OBJECT",
						"name": "AuditTextArrayDiff"
					},
					{
						"kind": "OBJECT",
						"name": "AuditTextDiff"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AuditEnumDiff",
				"fields": [
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "newValue",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "oldValue",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "AuditDiff"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AuditMoneyDiff",
				"fields": [
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "newValue",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "oldValue",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "AuditDiff"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AuditNumberArrayDiff",
				"fields": [
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "newValue",
						"type": {
							"kind": "LIST",
							"ofType": {
								"kind": "NON_NULL",
								"ofType": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						},
						"args": []
					},
					{
						"name": "oldValue",
						"type": {
							"kind": "LIST",
							"ofType": {
								"kind": "NON_NULL",
								"ofType": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "AuditDiff"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AuditNumberDiff",
				"fields": [
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "newValue",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "oldValue",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "AuditDiff"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AuditOrderAddress",
				"fields": [
					{
						"name": "action",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "diffs",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "AuditDiff",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "order",
						"type": {
							"kind": "OBJECT",
							"name": "Order",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "orderAddress",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderAddress",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "source",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "user",
						"type": {
							"kind": "OBJECT",
							"name": "User",
							"ofType": null
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Audit"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AuditOrderPayment",
				"fields": [
					{
						"name": "action",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "diffs",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "AuditDiff",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "order",
						"type": {
							"kind": "OBJECT",
							"name": "Order",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "orderPayment",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderPayment",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "source",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "user",
						"type": {
							"kind": "OBJECT",
							"name": "User",
							"ofType": null
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Audit"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AuditProduct",
				"fields": [
					{
						"name": "action",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "diffs",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "AuditDiff",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "source",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "user",
						"type": {
							"kind": "OBJECT",
							"name": "User",
							"ofType": null
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Audit"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AuditProductAsset",
				"fields": [
					{
						"name": "action",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "diffs",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "AuditDiff",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productAsset",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductAsset",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "source",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "user",
						"type": {
							"kind": "OBJECT",
							"name": "User",
							"ofType": null
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Audit"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AuditProductAttributeValue",
				"fields": [
					{
						"name": "action",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "diffs",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "AuditDiff",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productAttributeValue",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductAttributeValue",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "source",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "user",
						"type": {
							"kind": "OBJECT",
							"name": "User",
							"ofType": null
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Audit"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AuditProductMedia",
				"fields": [
					{
						"name": "action",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "diffs",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "AuditDiff",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productMedia",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductMedia",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "source",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "user",
						"type": {
							"kind": "OBJECT",
							"name": "User",
							"ofType": null
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Audit"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AuditTextArrayDiff",
				"fields": [
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "newValue",
						"type": {
							"kind": "LIST",
							"ofType": {
								"kind": "NON_NULL",
								"ofType": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						},
						"args": []
					},
					{
						"name": "oldValue",
						"type": {
							"kind": "LIST",
							"ofType": {
								"kind": "NON_NULL",
								"ofType": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "AuditDiff"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AuditTextDiff",
				"fields": [
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "newValue",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "oldValue",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "AuditDiff"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "AuditsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "AuditsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "AuditsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Audit",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "Brand",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "logo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "number",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "parent",
						"type": {
							"kind": "OBJECT",
							"name": "Brand",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "productCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "url",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "BrandCreatePayload",
				"fields": [
					{
						"name": "brand",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Brand",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "BrandCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "BrandCreatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "BrandDeletePayload",
				"fields": [
					{
						"name": "brand",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Brand",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "BrandDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "BrandDeletePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "BrandResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "Brand"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "BrandUpdatePayload",
				"fields": [
					{
						"name": "brand",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Brand",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "BrandUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "BrandUpdatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "BrandsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "BrandsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "BrandsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Brand",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "Cart",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "giftCard",
						"type": {
							"kind": "OBJECT",
							"name": "GiftCard",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "hasFreeShipping",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isWishlist",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "price",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "products",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "CartProduct",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "promotionCode",
						"type": {
							"kind": "OBJECT",
							"name": "PromotionCode",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "promotions",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Promotion",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "recommendedProducts",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Product",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "relatedProductsByCategory",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "CartRelatedProductGroup",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CartCreatePayload",
				"fields": [
					{
						"name": "cart",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Cart",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CartCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CartCreatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CartDeletePayload",
				"fields": [
					{
						"name": "cart",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Cart",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CartDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CartDeletePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CartProduct",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "discounts",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "CartProductDiscount",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "price",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "SimpleProduct",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "properties",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "CartProductProperty",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "quantity",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "unitPrice",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CartProductCreatePayload",
				"fields": [
					{
						"name": "cart",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Cart",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "cartProduct",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartProduct",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CartProductCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CartProductCreatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "CartProductOutOfBoundsError"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CartProductDeletePayload",
				"fields": [
					{
						"name": "cart",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Cart",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "cartProduct",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartProduct",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CartProductDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CartProductDeletePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CartProductDiscount",
				"fields": [
					{
						"name": "amount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "promotion",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Promotion",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CartProductOutOfBoundsError",
				"fields": [
					{
						"name": "code",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "detailedMessage",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isError",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "message",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "GenericError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CartProductProperty",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CartProductUpdatePayload",
				"fields": [
					{
						"name": "cart",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Cart",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "cartProduct",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartProduct",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CartProductUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CartProductOutOfBoundsError"
					},
					{
						"kind": "OBJECT",
						"name": "CartProductUpdatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "INTERFACE",
				"name": "CartPromotion",
				"fields": [
					{
						"name": "activeFrom",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "activeTo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "continueProcessing",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "discountType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "filterRuleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isSticky",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "matchRuleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "priority",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "requiresLogin",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "usesPerCode",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "Promotion"
					}
				],
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CartPromotionClubPrice"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionFixedAmountFromCart"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionFixedAmountFromProduct"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionFreeShipping"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionFreebie"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionPercent"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionProductCartPromotionPrice"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CartPromotionClubPrice",
				"fields": [
					{
						"name": "activeFrom",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "activeTo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "continueProcessing",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "discount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartPromotionClubPriceDiscount",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "discountType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "filterRuleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isSticky",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "matchRuleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "priority",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "requiresLogin",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "usesPerCode",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "CartPromotion"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "Promotion"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CartPromotionClubPriceDiscount",
				"fields": [
					{
						"name": "discountAmount",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CartPromotionFixedAmountFromCart",
				"fields": [
					{
						"name": "activeFrom",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "activeTo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "continueProcessing",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "discount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartPromotionFixedAmountFromCartDiscount",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "discountType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "filterRuleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isSticky",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "matchRuleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "priority",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "requiresLogin",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "usesPerCode",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "CartPromotion"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "Promotion"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CartPromotionFixedAmountFromCartDiscount",
				"fields": [
					{
						"name": "amount",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CartPromotionFixedAmountFromProduct",
				"fields": [
					{
						"name": "activeFrom",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "activeTo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "continueProcessing",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "discount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartPromotionFixedAmountFromProductDiscount",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "discountType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "filterRuleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isSticky",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "matchRuleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "priority",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "requiresLogin",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "usesPerCode",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "CartPromotion"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "Promotion"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CartPromotionFixedAmountFromProductDiscount",
				"fields": [
					{
						"name": "amount",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "discountQuantityPerCart",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "discountQuantityPerProductRow",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CartPromotionFreeShipping",
				"fields": [
					{
						"name": "activeFrom",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "activeTo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "continueProcessing",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "discountType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "filterRuleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isSticky",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "matchRuleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "priority",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "requiresLogin",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "usesPerCode",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "CartPromotion"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "Promotion"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CartPromotionFreebie",
				"fields": [
					{
						"name": "activeFrom",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "activeTo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "continueProcessing",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "discount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartPromotionFreebieDiscount",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "discountType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "filterRuleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isSticky",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "matchRuleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "priority",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "requiresLogin",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "usesPerCode",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "CartPromotion"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "Promotion"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CartPromotionFreebieDiscount",
				"fields": [
					{
						"name": "divider",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "percent",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CartPromotionPercent",
				"fields": [
					{
						"name": "activeFrom",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "activeTo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "continueProcessing",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "discount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartPromotionPercentDiscount",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "discountType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "filterRuleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isSticky",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "matchRuleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "priority",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "requiresLogin",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "usesPerCode",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "CartPromotion"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "Promotion"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CartPromotionPercentDiscount",
				"fields": [
					{
						"name": "discountQuantityPerCart",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "discountQuantityPerProductRow",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "percent",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CartPromotionProductCartPromotionPrice",
				"fields": [
					{
						"name": "activeFrom",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "activeTo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "continueProcessing",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "discountType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "filterRuleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isSticky",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "matchRuleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "priority",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "requiresLogin",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "usesPerCode",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "CartPromotion"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "Promotion"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CartRecommendation",
				"fields": [
					{
						"name": "activeFrom",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "activeTo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "priority",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "products",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Product",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "productsRuleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "productsType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CartRecommendationAddProductsPayload",
				"fields": [
					{
						"name": "cartRecommendation",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartRecommendation",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "products",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Product",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CartRecommendationAddProductsUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CartRecommendationAddProductsPayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CartRecommendationCreatePayload",
				"fields": [
					{
						"name": "cartRecommendation",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartRecommendation",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CartRecommendationCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CartRecommendationCreatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CartRecommendationDeletePayload",
				"fields": [
					{
						"name": "cartRecommendation",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartRecommendation",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CartRecommendationDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CartRecommendationDeletePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CartRecommendationRemoveProductsPayload",
				"fields": [
					{
						"name": "cartRecommendation",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartRecommendation",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "products",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Product",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CartRecommendationRemoveProductsUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CartRecommendationRemoveProductsPayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "CartRecommendationResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CartRecommendation"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CartRecommendationUpdatePayload",
				"fields": [
					{
						"name": "cartRecommendation",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartRecommendation",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CartRecommendationUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CartRecommendationUpdatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CartRecommendationsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "CartRecommendationsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CartRecommendationsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartRecommendation",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CartRelatedProductGroup",
				"fields": [
					{
						"name": "category",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "products",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartRelatedProductsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CartRelatedProductsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "CartRelatedProductsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CartRelatedProductsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CartResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "Cart"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CartUpdatePayload",
				"fields": [
					{
						"name": "cart",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Cart",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CartUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CartUpdatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "INTERFACE",
				"name": "CatalogPromotion",
				"fields": [
					{
						"name": "activeFrom",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "activeTo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "continueProcessing",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "discountType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isSticky",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "matchProductCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "matchRuleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "priceType",
						"type": {
							"kind": "OBJECT",
							"name": "PriceType",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "priority",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "style",
						"type": {
							"kind": "OBJECT",
							"name": "PromotionStyle",
							"ofType": null
						},
						"args": [
							{
								"name": "allowDefault",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "Promotion"
					}
				],
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CatalogPromotionFixedAmount"
					},
					{
						"kind": "OBJECT",
						"name": "CatalogPromotionPercent"
					},
					{
						"kind": "OBJECT",
						"name": "CatalogPromotionProductPromotionPrice"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CatalogPromotionFixedAmount",
				"fields": [
					{
						"name": "activeFrom",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "activeTo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "continueProcessing",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "discount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CatalogPromotionFixedAmountDiscount",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "discountType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isSticky",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "matchProductCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "matchRuleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "priceType",
						"type": {
							"kind": "OBJECT",
							"name": "PriceType",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "priority",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "style",
						"type": {
							"kind": "OBJECT",
							"name": "PromotionStyle",
							"ofType": null
						},
						"args": [
							{
								"name": "allowDefault",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "CatalogPromotion"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "Promotion"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CatalogPromotionFixedAmountDiscount",
				"fields": [
					{
						"name": "amount",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CatalogPromotionPercent",
				"fields": [
					{
						"name": "activeFrom",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "activeTo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "continueProcessing",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "discount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CatalogPromotionPercentDiscount",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "discountType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isSticky",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "matchProductCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "matchRuleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "priceType",
						"type": {
							"kind": "OBJECT",
							"name": "PriceType",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "priority",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "style",
						"type": {
							"kind": "OBJECT",
							"name": "PromotionStyle",
							"ofType": null
						},
						"args": [
							{
								"name": "allowDefault",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "CatalogPromotion"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "Promotion"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CatalogPromotionPercentDiscount",
				"fields": [
					{
						"name": "percent",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CatalogPromotionProductPromotionPrice",
				"fields": [
					{
						"name": "activeFrom",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "activeTo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "continueProcessing",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "discountType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isSticky",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "matchProductCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "matchRuleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "priceType",
						"type": {
							"kind": "OBJECT",
							"name": "PriceType",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "priority",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "style",
						"type": {
							"kind": "OBJECT",
							"name": "PromotionStyle",
							"ofType": null
						},
						"args": [
							{
								"name": "allowDefault",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "CatalogPromotion"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "Promotion"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CategoriesConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "CategoriesEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CategoriesEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Category",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "Category",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "image",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "parent",
						"type": {
							"kind": "OBJECT",
							"name": "Category",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "pimCode",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "productCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "productsPerPage",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "publishedFrom",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "publishedTo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "seo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CategorySeo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "taxonomyId",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CategoryAddProductsPayload",
				"fields": [
					{
						"name": "category",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Category",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "products",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Product",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CategoryAddProductsUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CategoryAddProductsPayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CategoryCreatePayload",
				"fields": [
					{
						"name": "category",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Category",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CategoryCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CategoryCreatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CategoryDeletePayload",
				"fields": [
					{
						"name": "category",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Category",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CategoryDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CategoryDeletePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CategoryDuplicatePayload",
				"fields": [
					{
						"name": "category",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Category",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CategoryDuplicateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CategoryDuplicatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CategoryRemoveProductsPayload",
				"fields": [
					{
						"name": "category",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Category",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "products",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Product",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CategoryRemoveProductsUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CategoryRemoveProductsPayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CategoryReorderPayload",
				"fields": [
					{
						"name": "categories",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Category",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CategoryReorderUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CategoryReorderPayload"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "CategoryResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "Category"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CategorySeo",
				"fields": [
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "hasCustomSlug",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "keywords",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "slug",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CategoryUpdatePayload",
				"fields": [
					{
						"name": "category",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Category",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CategoryUpdateSeoPayload",
				"fields": [
					{
						"name": "category",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Category",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CategoryUpdateSeoUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CategoryUpdateSeoPayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "CategoryUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CategoryUpdatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CompaniesConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "CompaniesEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CompaniesEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Company",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "Company",
				"fields": [
					{
						"name": "addresses",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CompanyAddressesConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "businessIdentityCode",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "contact",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Customer",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "customerCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "customers",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CompanyCustomersConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "orderStatistics",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CompanyOrderStatistics",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "orders",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrdersConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CompanyAddCustomerPayload",
				"fields": [
					{
						"name": "company",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Company",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "customer",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Customer",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "role",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CompanyAddCustomerUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CompanyAddCustomerPayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CompanyAddress",
				"fields": [
					{
						"name": "address",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "city",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "countryCode",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "firstName",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "lastName",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "phone",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "postalCode",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CompanyAddressCreatePayload",
				"fields": [
					{
						"name": "company",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Company",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "companyAddress",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CompanyAddress",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CompanyAddressCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CompanyAddressCreatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CompanyAddressDeletePayload",
				"fields": [
					{
						"name": "company",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Company",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "companyAddress",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CompanyAddress",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CompanyAddressDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CompanyAddressDeletePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "CompanyAddressResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CompanyAddress"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CompanyAddressUpdatePayload",
				"fields": [
					{
						"name": "company",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Company",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "companyAddress",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CompanyAddress",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CompanyAddressUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CompanyAddressUpdatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CompanyAddressesConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "CompanyAddressesEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CompanyAddressesEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CompanyAddress",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CompanyCreatePayload",
				"fields": [
					{
						"name": "company",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Company",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CompanyCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CompanyCreatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CompanyCustomer",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "customer",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Customer",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "role",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CompanyCustomersConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "CompanyCustomersEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CompanyCustomersEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CompanyCustomer",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CompanyDeletePayload",
				"fields": [
					{
						"name": "company",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Company",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CompanyDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CompanyDeletePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CompanyOrderStatistics",
				"fields": [
					{
						"name": "totalAmount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CompanyRemoveCustomerPayload",
				"fields": [
					{
						"name": "company",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Company",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "customer",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Customer",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "role",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CompanyRemoveCustomerUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CompanyRemoveCustomerPayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "CompanyResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "Company"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CompanyUpdateCustomerPayload",
				"fields": [
					{
						"name": "company",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Company",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "customer",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Customer",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "role",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CompanyUpdateCustomerUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CompanyUpdateCustomerPayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CompanyUpdatePayload",
				"fields": [
					{
						"name": "company",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Company",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CompanyUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CompanyUpdatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ConfigurableProduct",
				"fields": [
					{
						"name": "assets",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductAsset",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "attributes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductAttributeValue",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": [
							{
								"name": "attributeIds",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "code",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "showInProductListing",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "showInProductPage",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "brand",
						"type": {
							"kind": "OBJECT",
							"name": "Brand",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "brandLogo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "brandTitle",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "cartRecommendations",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "CartRecommendation",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "categories",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Category",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "collections",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductCollection",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "configuration",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductConfiguration",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "availableProductsOnly",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "configurationErrors",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "crossellProducts",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "dimensions",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductDimensions",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "disclaimers",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductDisclaimer",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": [
							{
								"name": "isPublished",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "fetchRelations",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductRelation",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "group",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "hasCustomName",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "internalIdentifier",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "isGiftCard",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "listingImage",
						"type": {
							"kind": "OBJECT",
							"name": "ProductImage",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "mainCategory",
						"type": {
							"kind": "OBJECT",
							"name": "Category",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "maskMedias",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductMaskMedia",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "matchRelations",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductRelation",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "measurementImage",
						"type": {
							"kind": "OBJECT",
							"name": "ProductAsset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "medias",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductMedia",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "parcels",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductParcel",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "productBadges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductBadge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "productClass",
						"type": {
							"kind": "OBJECT",
							"name": "ProductClass",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "properties",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductProperty",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "publishedAt",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "qaItems",
						"type": {
							"kind": "LIST",
							"ofType": {
								"kind": "NON_NULL",
								"ofType": {
									"name": "QuestionAndAnswer",
									"kind": "OBJECT",
									"ofType": null
								}
							}
						},
						"args": []
					},
					{
						"name": "relatedProducts",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "seo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductSeo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "shortDescription",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "sku",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "specification",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "upsellProducts",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "Product"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "Customer",
				"fields": [
					{
						"name": "addresses",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CustomerAddressesConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "allowEmailMarketing",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "allowSmsMarketing",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "auth0UserId",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "company",
						"type": {
							"kind": "OBJECT",
							"name": "Company",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "countryCode",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "email",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "firstName",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "hasLoggedIn",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isFirstTimeSetupDone",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "lastName",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "number",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "orderStatistics",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CustomerOrderStatistics",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "orders",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrdersConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "phone",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "requiresEmailVerification",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CustomerAddress",
				"fields": [
					{
						"name": "address",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "businessIdentityCode",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "city",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "companyName",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "countryCode",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "firstName",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "lastName",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "phone",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "postalCode",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CustomerAddressCreatePayload",
				"fields": [
					{
						"name": "customer",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Customer",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "customerAddress",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CustomerAddress",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CustomerAddressCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CustomerAddressCreatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CustomerAddressDeletePayload",
				"fields": [
					{
						"name": "customer",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Customer",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "customerAddress",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CustomerAddress",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CustomerAddressDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CustomerAddressDeletePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "CustomerAddressResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CustomerAddress"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CustomerAddressUpdatePayload",
				"fields": [
					{
						"name": "customer",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Customer",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "customerAddress",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CustomerAddress",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CustomerAddressUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CustomerAddressUpdatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CustomerAddressesConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "CustomerAddressesEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CustomerAddressesEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CustomerAddress",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CustomerCreatePayload",
				"fields": [
					{
						"name": "customer",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Customer",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CustomerCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CustomerCreatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "CustomerExistsError"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CustomerDeletePayload",
				"fields": [
					{
						"name": "customer",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Customer",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CustomerDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CustomerDeletePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CustomerExistsError",
				"fields": [
					{
						"name": "code",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "detailedMessage",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "email",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isError",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "message",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "GenericError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CustomerOrderStatistics",
				"fields": [
					{
						"name": "totalAmount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CustomerResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "Customer"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CustomerStatistics",
				"fields": [
					{
						"name": "date",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "newCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CustomerUpdatePayload",
				"fields": [
					{
						"name": "customer",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Customer",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "CustomerUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CustomerUpdatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "CustomersConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "CustomersEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "CustomersEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Customer",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "Editor",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "fields",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "EditorField",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isSticky",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "pendingUpdateCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "productCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "EditorAttributeField",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "EditorField"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "EditorAttributeUpdate",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "EditorUpdate"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "EditorCreatePayload",
				"fields": [
					{
						"name": "editor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Editor",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "EditorCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EditorCreatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "EditorDeletePayload",
				"fields": [
					{
						"name": "editor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Editor",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "EditorDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EditorDeletePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "EditorDuplicatePayload",
				"fields": [
					{
						"name": "editor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Editor",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "EditorDuplicateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EditorDuplicatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "EditorExecutePayload",
				"fields": [
					{
						"name": "editor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Editor",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "EditorExecuteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EditorExecutePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "EditorExportPayload",
				"fields": [
					{
						"name": "editor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Editor",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "EditorExportUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EditorExportPayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "INTERFACE",
				"name": "EditorField",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				],
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EditorAttributeField"
					},
					{
						"kind": "OBJECT",
						"name": "EditorPriceTypeField"
					},
					{
						"kind": "OBJECT",
						"name": "EditorPropertyField"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "EditorFieldCreatePayload",
				"fields": [
					{
						"name": "editor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Editor",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "editorField",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "EditorField",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "EditorFieldCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EditorFieldCreatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "EditorFieldDeletePayload",
				"fields": [
					{
						"name": "editor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Editor",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "editorField",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "EditorField",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "EditorFieldDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EditorFieldDeletePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "EditorFieldUpdatePayload",
				"fields": [
					{
						"name": "editor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Editor",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "editorField",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "EditorField",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "EditorFieldUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EditorFieldUpdatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "EditorPriceTypeField",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "priceType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PriceType",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "EditorField"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "EditorPriceTypeUpdate",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "priceType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PriceType",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "EditorUpdate"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "EditorPropertyField",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "property",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "EditorField"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "EditorPropertyUpdate",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "property",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "EditorUpdate"
					},
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "EditorReorderFieldsPayload",
				"fields": [
					{
						"name": "editor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Editor",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "EditorReorderFieldsUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EditorReorderFieldsPayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "EditorResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "Editor"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "INTERFACE",
				"name": "EditorUpdate",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				],
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EditorAttributeUpdate"
					},
					{
						"kind": "OBJECT",
						"name": "EditorPriceTypeUpdate"
					},
					{
						"kind": "OBJECT",
						"name": "EditorPropertyUpdate"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "EditorUpdatePayload",
				"fields": [
					{
						"name": "editor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Editor",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "EditorUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EditorUpdatePayload"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "EditorUpdateUpsertPayload",
				"fields": [
					{
						"name": "editor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Editor",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "editorUpdates",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "EditorUpdate",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "EditorUpdateUpsertUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EditorUpdateUpsertPayload"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "EditorUpdatesConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "EditorUpdatesEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "EditorUpdatesEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "EditorUpdate",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "EditorsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "EditorsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "EditorsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Editor",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "EmailNotificationTemplate",
				"fields": [
					{
						"name": "content",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "contentType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "from",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "receivers",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "NotificationTemplate"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "EntityNotFoundError",
				"fields": [
					{
						"name": "code",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "detailedMessage",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isError",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "message",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "GenericError"
					}
				]
			},
			{
				"kind": "INTERFACE",
				"name": "GenericError",
				"fields": [
					{
						"name": "code",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "detailedMessage",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "isError",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "message",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [],
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CartProductOutOfBoundsError"
					},
					{
						"kind": "OBJECT",
						"name": "CustomerExistsError"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "GiftCard",
				"fields": [
					{
						"name": "code",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createDate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "email",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "giftCardOrders",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "GiftCardOrder",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "includePending",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "initialAmount",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "number",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "orderProduct",
						"type": {
							"kind": "OBJECT",
							"name": "OrderProduct",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "remainingAmount",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "validUntil",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "GiftCardDeletePayload",
				"fields": [
					{
						"name": "giftCard",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "GiftCard",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "GiftCardDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "GiftCardDeletePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "GiftCardOrder",
				"fields": [
					{
						"name": "amount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "confirmedAt",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "giftCard",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "GiftCard",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "order",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Order",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "GiftCardResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "GiftCard"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "GiftCardsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "GiftCardsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "GiftCardsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "GiftCard",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "InvalidInputError",
				"fields": [
					{
						"name": "code",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "detailedMessage",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isError",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "message",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "GenericError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "Money",
				"fields": [
					{
						"name": "amount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "currencyCode",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "MoneyRange",
				"fields": [
					{
						"name": "max",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "min",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "Mutation",
				"fields": [
					{
						"name": "attributeCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "attributeDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "attributeGroupAddAttributes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeGroupAddAttributesUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "attributeGroupId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "attributeIds",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							}
						]
					},
					{
						"name": "attributeGroupCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeGroupCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "attributeGroupDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeGroupDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "attributeGroupRemoveAttributes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeGroupRemoveAttributesUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "attributeGroupId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "attributeIds",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							}
						]
					},
					{
						"name": "attributeGroupReorder",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeGroupReorderUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "order",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							}
						]
					},
					{
						"name": "attributeGroupReorderAttributes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeGroupReorderAttributesUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "order",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "attributeGroupUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeGroupUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "attributeOptionCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeOptionCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "attributeOptionDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeOptionDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "attributeOptionUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeOptionUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "attributeReorderOptions",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeReorderOptionsUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "order",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "attributeUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "brandCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "BrandCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "brandDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "BrandDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "brandUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "BrandUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "cartCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "cartDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "cartProductCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartProductCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "cartProductDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartProductDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "cartProductUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartProductUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "cartRecommendationAddProducts",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartRecommendationAddProductsUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "cartRecommendationId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "productIds",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							}
						]
					},
					{
						"name": "cartRecommendationCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartRecommendationCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "cartRecommendationDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartRecommendationDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "cartRecommendationRemoveProducts",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartRecommendationRemoveProductsUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "cartRecommendationId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "productIds",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							}
						]
					},
					{
						"name": "cartRecommendationSetRuleset",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartRecommendationUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "rulesetId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "type",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "cartRecommendationUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartRecommendationUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "cartUpdateGiftCard",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "giftCardCode",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "cartUpdatePromotionCode",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "promotionCode",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "categoryAddProducts",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CategoryAddProductsUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "categoryId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "productIds",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							}
						]
					},
					{
						"name": "categoryCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CategoryCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "categoryDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CategoryDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "categoryDuplicate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CategoryDuplicateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "categoryRemoveProducts",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CategoryRemoveProductsUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "categoryId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "productIds",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							}
						]
					},
					{
						"name": "categoryReorder",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CategoryReorderUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "order",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							}
						]
					},
					{
						"name": "categorySetRuleset",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CategoryUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "rulesetId",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "categoryUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CategoryUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "categoryUpdateSeo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CategoryUpdateSeoUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "companyAddCustomer",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CompanyAddCustomerUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "companyId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "customerId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "role",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "companyAddressCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CompanyAddressCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "companyAddressDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CompanyAddressDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "companyAddressUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CompanyAddressUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "companyCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CompanyCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "companyDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CompanyDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "companyRemoveCustomer",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CompanyRemoveCustomerUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "companyId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "customerId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "companyUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CompanyUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "companyUpdateCustomer",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CompanyUpdateCustomerUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "companyId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "customerId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "role",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "customerAddressCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CustomerAddressCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "customerAddressDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CustomerAddressDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "customerAddressUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CustomerAddressUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "customerCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CustomerCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "customerDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CustomerDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "customerFinishFirstTimeSetup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CustomerUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "customerSendEmailVerification",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CustomerUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "customerUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CustomerUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "editorCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "EditorCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "editorDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "EditorDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "editorDuplicate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "EditorDuplicateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "editorExecute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "EditorExecuteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "editorExport",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "EditorExportUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "editorFieldCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "EditorFieldCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "editorFieldDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "EditorFieldDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "editorFieldUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "EditorFieldUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "editorReorderFields",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "EditorReorderFieldsUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "order",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "editorUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "EditorUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "editorUpdateUpsert",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "EditorUpdateUpsertUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "giftCardCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "GiftCardResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "giftCardDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "GiftCardDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "notificationMarkAsRead",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "NotificationMarkAsReadUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "ids",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							}
						]
					},
					{
						"name": "notificationTemplateCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "NotificationTemplateCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "notificationTemplateDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "NotificationTemplateDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "notificationTemplatePreview",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "NotificationTemplatePreviewUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "notificationTemplateUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "NotificationTemplateUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderAddressCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderAddressCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderAddressCreateFromCustomerAddress",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderAddressCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "customerAddressId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderAddressUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderAddressUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderCancel",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderCancelUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderClearHandler",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderComplete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderCompleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderCreateFromCart",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "cartId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderFinalize",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderFinalizeUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderPaymentCancel",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderPaymentCancelUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderPaymentComplete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderPaymentCompleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderPaymentCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderPaymentCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderPaymentExecute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderPaymentExecuteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderPaymentNotify",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderPaymentNotifyUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderPaymentUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderPaymentUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderReceive",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderReceiveUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderSetBillingAddress",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "addressId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderSetCustomer",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "customerId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderSetHandler",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "userId",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderSetPaymentMethod",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "paymentData",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "paymentMethodId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderSetShippingAddress",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "addressId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderSetShippingMethod",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "postalCode",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "shippingData",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "shippingMethodId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderUndoFinalize",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderUndoFinalizeUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "outletCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OutletCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "outletDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OutletDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "outletUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OutletUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "paymentMethodCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethodCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "paymentMethodDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethodDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "paymentMethodGroupAddPaymentMethods",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethodGroupAddPaymentMethodsUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "paymentMethodGroupId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "paymentMethodIds",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							}
						]
					},
					{
						"name": "paymentMethodGroupCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethodGroupCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "paymentMethodGroupDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethodGroupDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "paymentMethodGroupRemovePaymentMethods",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethodGroupRemovePaymentMethodsUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "paymentMethodGroupId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "paymentMethodIds",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							}
						]
					},
					{
						"name": "paymentMethodGroupReorder",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethodGroupReorderUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "order",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							}
						]
					},
					{
						"name": "paymentMethodGroupReorderPaymentMethods",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethodGroupReorderPaymentMethodsUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "order",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "paymentMethodGroupUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethodGroupUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "paymentMethodReorder",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethodReorderUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "order",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							}
						]
					},
					{
						"name": "paymentMethodUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethodUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "priceTypeCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PriceTypeCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "priceTypeDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PriceTypeDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "priceTypeUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PriceTypeUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productAddCategories",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductAddCategoriesUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "categoryIds",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							},
							{
								"name": "productId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productAssetsCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductAssetCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productAssetsDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductAssetDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productAssetsUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductAssetUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productBadgeCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductBadgeCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productBadgeDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductBadgeDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productBadgeDuplicate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductBadgeDuplicateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productBadgeSetRuleset",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductBadgeUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "rulesetId",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productBadgeUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductBadgeUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productClassCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductClassCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productClassDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductClassDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productClassUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductClassUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productClearStocks",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductClearStocksUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "productIds",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							}
						]
					},
					{
						"name": "productCollectionAddProducts",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductCollectionAddProductsUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "productCollectionId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "productIds",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							}
						]
					},
					{
						"name": "productCollectionCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductCollectionCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productCollectionDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductCollectionDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productCollectionDuplicate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductCollectionDuplicateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productCollectionRemoveProducts",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductCollectionRemoveProductsUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "productCollectionId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "productIds",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							}
						]
					},
					{
						"name": "productCollectionSetRuleset",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductCollectionUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "rulesetId",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productCollectionUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductCollectionUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productDisclaimerCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductDisclaimerCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productDisclaimerDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductDisclaimerDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productDisclaimerDuplicate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductDisclaimerDuplicateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productDisclaimerSetRuleset",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductDisclaimerUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "rulesetId",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productDisclaimerUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductDisclaimerUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productDuplicate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductDuplicateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productExportCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductExportCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productExportDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductExportDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productExportUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductExportUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productGroupAddAttributes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductGroupAddAttributesUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "attributeIds",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							},
							{
								"name": "productGroupId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productGroupCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductGroupCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productGroupDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductGroupDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productGroupRemoveAttributes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductGroupRemoveAttributesUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "attributeIds",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							},
							{
								"name": "productGroupId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productGroupUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductGroupUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productImportCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductImportCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productImportDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductImportDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productImportExecute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductImportExecuteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productImportUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductImportUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productMaskMediaCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductMaskMediaCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productMaskMediaDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductMaskMediaDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productMaskMediaUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductMaskMediaUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productMediasCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductMediaCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productMediasDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductMediaDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productMediasUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductMediaUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productParcelCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductParcelCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productParcelDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductParcelDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productParcelUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductParcelUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productPriceTypeCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductPriceTypeCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productPriceTypeDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductPriceTypeDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productPriceTypeUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductPriceTypeUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productPropertyCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductPropertyCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productPropertyDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductPropertyDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productPropertyOptionCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductPropertyOptionCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productPropertyOptionDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductPropertyOptionDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productPropertyOptionUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductPropertyOptionUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productPropertyReorderOptions",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductPropertyReorderOptionsUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "order",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productPropertyUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductPropertyUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productRelationAddProducts",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductRelationAddProductsUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "productIds",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							},
							{
								"name": "productRelationId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "type",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productRelationCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductRelationCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productRelationDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductRelationDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productRelationRemoveProducts",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductRelationRemoveProductsUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "productIds",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							},
							{
								"name": "productRelationId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "type",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productRelationSetRuleset",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductRelationUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "rulesetId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "type",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productRelationUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductRelationUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productRemoveCategories",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductRemoveCategoriesUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "categoryIds",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							},
							{
								"name": "productId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productReorderAssets",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductReorderAssetsUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "order",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productReorderMedias",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductReorderMediasUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "order",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productReorderProperties",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductReorderPropertiesUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "order",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productSetBrand",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "brandId",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productSetDefaultMedia",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductSetDefaultMediaUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "mediaId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "productId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productSetMeasurementAsset",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductSetMeasurementAssetUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "assetId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "productId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productSetProductClass",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "productClassId",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productSetProductGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "productGroupId",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productSetPromotionGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "promotionGroupId",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productSetTaxClass",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "taxClassId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productUpdateAttributes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductUpdateAttributesUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "values",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productUpdateCart",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productUpdateConfigurableData",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductUpdateConfigurableDataUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "attributes",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							},
							{
								"name": "childProductIds",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							},
							{
								"name": "defaultChildProductId",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "productId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productUpdateDimensions",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productUpdateInventory",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productUpdateOutlets",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productUpdatePricing",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productUpdateSeo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productValueCollectionAddProducts",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductValueCollectionAddProductsUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "productIds",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							},
							{
								"name": "productValueCollectionId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productValueCollectionCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductValueCollectionCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productValueCollectionDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductValueCollectionDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productValueCollectionRemoveProducts",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductValueCollectionRemoveProductsUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "productIds",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							},
							{
								"name": "productValueCollectionId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productValueCollectionSetRuleset",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductValueCollectionUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "rulesetId",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productValueCollectionUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductValueCollectionUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "promotionAddCodes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionAddCodesUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "codes",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "promotionCodeDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionCodeDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "promotionCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "promotionDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "promotionDeleteCodes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionDeleteCodesUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "codeIds",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "promotionDuplicate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionDuplicateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "promotionGenerateCodes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionGenerateCodesUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "promotionGroupCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionGroupCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "promotionGroupDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionGroupDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "promotionGroupUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionGroupUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "promotionSetFilterRuleset",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "rulesetId",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "promotionSetMatchRuleset",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "rulesetId",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "promotionSetPriceType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "priceTypeId",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "promotionSetStyle",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "promotionStyleId",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "promotionStyleCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionStyleCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "promotionStyleDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionStyleDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "promotionStyleDuplicate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionStyleDuplicateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "promotionStyleUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionStyleUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "promotionUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "rulesetCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "RulesetCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "rulesetDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "RulesetDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "rulesetRefresh",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "RulesetRefreshUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "rulesetUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "RulesetUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "shippingAreaCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingAreaCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "shippingAreaDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingAreaDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "shippingAreaUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingAreaUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "shippingMethodAreaCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodAreaCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "shippingMethodAreaDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodAreaDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "shippingMethodAreaUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodAreaUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "shippingMethodCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "shippingMethodDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "shippingMethodDuplicate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodDuplicateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "shippingMethodGroupAddShippingMethods",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodGroupAddShippingMethodsUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "shippingMethodGroupId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "shippingMethodIds",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							}
						]
					},
					{
						"name": "shippingMethodGroupCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodGroupCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "shippingMethodGroupDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodGroupDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "shippingMethodGroupRemoveShippingMethods",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodGroupRemoveShippingMethodsUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "shippingMethodGroupId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "shippingMethodIds",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							}
						]
					},
					{
						"name": "shippingMethodGroupReorder",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodGroupReorderUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "order",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							}
						]
					},
					{
						"name": "shippingMethodGroupReorderShippingMethods",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodGroupReorderShippingMethodsUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "order",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "shippingMethodGroupUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodGroupUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "shippingMethodServiceCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodServiceCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "shippingMethodServiceDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodServiceDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "shippingMethodServiceUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodServiceUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "shippingMethodSetTaxClass",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "taxClassId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "shippingMethodUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "storeCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "StoreCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "storeDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "StoreDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "storeUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "StoreUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "taxClassCreate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "TaxClassCreateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "taxClassDelete",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "TaxClassDeleteUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "taxClassUpdate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "TaxClassUpdateUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "userSetRoles",
						"type": {
							"kind": "OBJECT",
							"name": "UserSetRolesPayload",
							"ofType": null
						},
						"args": [
							{
								"name": "roleIds",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "LIST",
										"ofType": {
											"kind": "NON_NULL",
											"ofType": {
												"kind": "SCALAR",
												"name": "Any"
											}
										}
									}
								}
							},
							{
								"name": "userId",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "userUpdate",
						"type": {
							"kind": "OBJECT",
							"name": "UserUpdatePayload",
							"ofType": null
						},
						"args": [
							{
								"name": "input",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					}
				],
				"interfaces": []
			},
			{
				"kind": "INTERFACE",
				"name": "Node",
				"fields": [
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [],
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "Attribute"
					},
					{
						"kind": "OBJECT",
						"name": "AttributeGroup"
					},
					{
						"kind": "OBJECT",
						"name": "AttributeOption"
					},
					{
						"kind": "OBJECT",
						"name": "AuditCategory"
					},
					{
						"kind": "OBJECT",
						"name": "AuditCustomer"
					},
					{
						"kind": "OBJECT",
						"name": "AuditCustomerAddress"
					},
					{
						"kind": "OBJECT",
						"name": "AuditOrderAddress"
					},
					{
						"kind": "OBJECT",
						"name": "AuditOrderPayment"
					},
					{
						"kind": "OBJECT",
						"name": "AuditProduct"
					},
					{
						"kind": "OBJECT",
						"name": "AuditProductAsset"
					},
					{
						"kind": "OBJECT",
						"name": "AuditProductAttributeValue"
					},
					{
						"kind": "OBJECT",
						"name": "AuditProductMedia"
					},
					{
						"kind": "OBJECT",
						"name": "Brand"
					},
					{
						"kind": "OBJECT",
						"name": "Cart"
					},
					{
						"kind": "OBJECT",
						"name": "CartProduct"
					},
					{
						"kind": "OBJECT",
						"name": "CartProductProperty"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionClubPrice"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionFixedAmountFromCart"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionFixedAmountFromProduct"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionFreeShipping"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionFreebie"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionPercent"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionProductCartPromotionPrice"
					},
					{
						"kind": "OBJECT",
						"name": "CartRecommendation"
					},
					{
						"kind": "OBJECT",
						"name": "CatalogPromotionFixedAmount"
					},
					{
						"kind": "OBJECT",
						"name": "CatalogPromotionPercent"
					},
					{
						"kind": "OBJECT",
						"name": "CatalogPromotionProductPromotionPrice"
					},
					{
						"kind": "OBJECT",
						"name": "Category"
					},
					{
						"kind": "OBJECT",
						"name": "Company"
					},
					{
						"kind": "OBJECT",
						"name": "CompanyAddress"
					},
					{
						"kind": "OBJECT",
						"name": "CompanyCustomer"
					},
					{
						"kind": "OBJECT",
						"name": "ConfigurableProduct"
					},
					{
						"kind": "OBJECT",
						"name": "Customer"
					},
					{
						"kind": "OBJECT",
						"name": "CustomerAddress"
					},
					{
						"kind": "OBJECT",
						"name": "Editor"
					},
					{
						"kind": "OBJECT",
						"name": "EditorAttributeField"
					},
					{
						"kind": "OBJECT",
						"name": "EditorAttributeUpdate"
					},
					{
						"kind": "OBJECT",
						"name": "EditorPriceTypeField"
					},
					{
						"kind": "OBJECT",
						"name": "EditorPriceTypeUpdate"
					},
					{
						"kind": "OBJECT",
						"name": "EditorPropertyField"
					},
					{
						"kind": "OBJECT",
						"name": "EditorPropertyUpdate"
					},
					{
						"kind": "OBJECT",
						"name": "EmailNotificationTemplate"
					},
					{
						"kind": "OBJECT",
						"name": "GiftCard"
					},
					{
						"kind": "OBJECT",
						"name": "GiftCardOrder"
					},
					{
						"kind": "OBJECT",
						"name": "Notification"
					},
					{
						"kind": "OBJECT",
						"name": "NotificationAttachment"
					},
					{
						"kind": "OBJECT",
						"name": "Order"
					},
					{
						"kind": "OBJECT",
						"name": "OrderAddress"
					},
					{
						"kind": "OBJECT",
						"name": "OrderHandlerEvent"
					},
					{
						"kind": "OBJECT",
						"name": "OrderNotificationEvent"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPayment"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPaymentData"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPaymentEvent"
					},
					{
						"kind": "OBJECT",
						"name": "OrderProduct"
					},
					{
						"kind": "OBJECT",
						"name": "OrderProductDiscount"
					},
					{
						"kind": "OBJECT",
						"name": "OrderProductProperty"
					},
					{
						"kind": "OBJECT",
						"name": "OrderStateEvent"
					},
					{
						"kind": "OBJECT",
						"name": "Outlet"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodAvarda"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodAvardaEstonia"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodData"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodEsto"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodGroup"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodHolmbank"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodInbank"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodMaksekeskus"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodMontonio"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodPaytrail"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodPaywerk"
					},
					{
						"kind": "OBJECT",
						"name": "PriceType"
					},
					{
						"kind": "OBJECT",
						"name": "ProductAsset"
					},
					{
						"kind": "OBJECT",
						"name": "ProductBadge"
					},
					{
						"kind": "OBJECT",
						"name": "ProductClass"
					},
					{
						"kind": "OBJECT",
						"name": "ProductCollection"
					},
					{
						"kind": "OBJECT",
						"name": "ProductColorValue"
					},
					{
						"kind": "OBJECT",
						"name": "ProductConfigurableAttribute"
					},
					{
						"kind": "OBJECT",
						"name": "ProductDateValue"
					},
					{
						"kind": "OBJECT",
						"name": "ProductDisclaimer"
					},
					{
						"kind": "OBJECT",
						"name": "ProductDropdownValue"
					},
					{
						"kind": "OBJECT",
						"name": "ProductExport"
					},
					{
						"kind": "OBJECT",
						"name": "ProductGroup"
					},
					{
						"kind": "OBJECT",
						"name": "ProductImage"
					},
					{
						"kind": "OBJECT",
						"name": "ProductImport"
					},
					{
						"kind": "OBJECT",
						"name": "ProductMaskMedia"
					},
					{
						"kind": "OBJECT",
						"name": "ProductModel"
					},
					{
						"kind": "OBJECT",
						"name": "ProductMultiselectValue"
					},
					{
						"kind": "OBJECT",
						"name": "ProductNumberValue"
					},
					{
						"kind": "OBJECT",
						"name": "ProductOutlet"
					},
					{
						"kind": "OBJECT",
						"name": "ProductParcel"
					},
					{
						"kind": "OBJECT",
						"name": "ProductPriceType"
					},
					{
						"kind": "OBJECT",
						"name": "ProductProperty"
					},
					{
						"kind": "OBJECT",
						"name": "ProductPropertyOption"
					},
					{
						"kind": "OBJECT",
						"name": "ProductRelation"
					},
					{
						"kind": "OBJECT",
						"name": "ProductTagsValue"
					},
					{
						"kind": "OBJECT",
						"name": "ProductTextValue"
					},
					{
						"kind": "OBJECT",
						"name": "ProductTextareaValue"
					},
					{
						"kind": "OBJECT",
						"name": "ProductToggleValue"
					},
					{
						"kind": "OBJECT",
						"name": "ProductValueCollection"
					},
					{
						"kind": "OBJECT",
						"name": "ProductVideo"
					},
					{
						"kind": "OBJECT",
						"name": "PromotionCode"
					},
					{
						"kind": "OBJECT",
						"name": "PromotionGroup"
					},
					{
						"kind": "OBJECT",
						"name": "PromotionStyle"
					},
					{
						"kind": "OBJECT",
						"name": "Ruleset"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetBrandRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetCartProductAttributeValueRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetCustomerLoginStateRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetCustomerTypeRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetGroup"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetGroupItem"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetNumericRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetOrderPaymentMethodRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetOrderShippingMethodRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductAttributeValueRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductCategoriesRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductClassRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductCollectionsRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductCreatedAtRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductGroupRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductIdRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductInventoryStateRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductOutletQuantityRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductPromotionGroupRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductStateRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductTypeRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductValueCollectionsRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetShippingAddressPostCodeRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetShippingAddressShippingAreaRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetTextRule"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingArea"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodArea"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodData"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodEmail"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodGroup"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodHakonen"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodLocalDelivery"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodMatkahuolto"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodOmniva"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodPickUpFromStore"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodPosti"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodService"
					},
					{
						"kind": "OBJECT",
						"name": "SimpleProduct"
					},
					{
						"kind": "OBJECT",
						"name": "Store"
					},
					{
						"kind": "OBJECT",
						"name": "TaxClass"
					},
					{
						"kind": "OBJECT",
						"name": "WebhookNotificationTemplate"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "Notification",
				"fields": [
					{
						"name": "attachments",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "NotificationAttachment",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "item",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Node",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "readAt",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "NotificationAttachment",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "url",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "NotificationMarkAsReadPayload",
				"fields": [
					{
						"name": "notifications",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Notification",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "NotificationMarkAsReadUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "NotificationMarkAsReadPayload"
					}
				]
			},
			{
				"kind": "INTERFACE",
				"name": "NotificationTemplate",
				"fields": [
					{
						"name": "contentType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				],
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EmailNotificationTemplate"
					},
					{
						"kind": "OBJECT",
						"name": "WebhookNotificationTemplate"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "NotificationTemplateCreatePayload",
				"fields": [
					{
						"name": "notificationTemplate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "NotificationTemplate",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "NotificationTemplateCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "NotificationTemplateCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "NotificationTemplateDeletePayload",
				"fields": [
					{
						"name": "notificationTemplate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "NotificationTemplate",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "NotificationTemplateDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "NotificationTemplateDeletePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "NotificationTemplatePreviewPayload",
				"fields": [
					{
						"name": "content",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "orderData",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "NotificationTemplatePreviewUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "NotificationTemplatePreviewPayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "NotificationTemplateResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EmailNotificationTemplate"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "WebhookNotificationTemplate"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "NotificationTemplateUpdatePayload",
				"fields": [
					{
						"name": "notificationTemplate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "NotificationTemplate",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "NotificationTemplateUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "NotificationTemplateUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "NotificationTemplatesConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "NotificationTemplatesEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "NotificationTemplatesEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "NotificationTemplate",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "NotificationsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "NotificationsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "NotificationsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Notification",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "Order",
				"fields": [
					{
						"name": "availablePaymentMethods",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PaymentMethod",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "availableShippingMethods",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethod",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": [
							{
								"name": "postalCode",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "billingAddress",
						"type": {
							"kind": "OBJECT",
							"name": "OrderAddress",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "company",
						"type": {
							"kind": "OBJECT",
							"name": "Company",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "customer",
						"type": {
							"kind": "OBJECT",
							"name": "Customer",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "deliveryEstimate",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "deliveryInfo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "giftCardOrders",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "GiftCardOrder",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "handler",
						"type": {
							"kind": "OBJECT",
							"name": "User",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "hasFreeShipping",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "ipAddress",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "number",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "orderLevelDiscountsAmount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "originalDeliveryEstimate",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "payment",
						"type": {
							"kind": "INTERFACE",
							"name": "OrderPaymentInfo",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "paymentMethod",
						"type": {
							"kind": "INTERFACE",
							"name": "PaymentMethod",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "products",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OrderProduct",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "productsAmount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "promotionCode",
						"type": {
							"kind": "OBJECT",
							"name": "PromotionCode",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "promotions",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Promotion",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "saleNumber",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "shipping",
						"type": {
							"kind": "INTERFACE",
							"name": "OrderShippingInfo",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "shippingAddress",
						"type": {
							"kind": "OBJECT",
							"name": "OrderAddress",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "taxLines",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OrderTaxLine",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "totalAmount",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "totalDiscountsAmount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalValue",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "wasLoggedIn",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderAddress",
				"fields": [
					{
						"name": "address",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "businessIdentityCode",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "city",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "companyName",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "countryCode",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "firstName",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "lastName",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "phone",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "postalCode",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderAddressCreatePayload",
				"fields": [
					{
						"name": "orderAddress",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderAddress",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "OrderAddressCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "OrderAddressCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderAddressUpdatePayload",
				"fields": [
					{
						"name": "order",
						"type": {
							"kind": "OBJECT",
							"name": "Order",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "orderAddress",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderAddress",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "OrderAddressUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "OrderAddressUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderCancelPayload",
				"fields": [
					{
						"name": "order",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Order",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "OrderCancelUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "OrderCancelPayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderCompletePayload",
				"fields": [
					{
						"name": "order",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Order",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "OrderCompleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "OrderCompletePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderCreatePayload",
				"fields": [
					{
						"name": "order",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Order",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "OrderCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "OrderCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderData",
				"fields": [
					{
						"name": "key",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "OrderDeletePayload",
				"fields": [
					{
						"name": "order",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Order",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "OrderDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "OrderDeletePayload"
					}
				]
			},
			{
				"kind": "INTERFACE",
				"name": "OrderEvent",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "orderState",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "user",
						"type": {
							"kind": "OBJECT",
							"name": "User",
							"ofType": null
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				],
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "OrderHandlerEvent"
					},
					{
						"kind": "OBJECT",
						"name": "OrderNotificationEvent"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPaymentEvent"
					},
					{
						"kind": "OBJECT",
						"name": "OrderStateEvent"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderEventsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OrderEventsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "OrderEventsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderEvent",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "OrderFinalizePayload",
				"fields": [
					{
						"name": "order",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Order",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "OrderFinalizeUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "OrderFinalizePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderHandlerEvent",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "handler",
						"type": {
							"kind": "OBJECT",
							"name": "User",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "orderState",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "user",
						"type": {
							"kind": "OBJECT",
							"name": "User",
							"ofType": null
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "OrderEvent"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderNotificationEvent",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "notificationTemplate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "NotificationTemplate",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "orderState",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "user",
						"type": {
							"kind": "OBJECT",
							"name": "User",
							"ofType": null
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "OrderEvent"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderPayment",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "fingerprint",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "paymentMethod",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentAvarda",
				"fields": [
					{
						"name": "purchaseId",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "token",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentAvardaEstonia",
				"fields": [
					{
						"name": "purchaseId",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "redirectUrl",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentCancelPayload",
				"fields": [
					{
						"name": "order",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Order",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "orderPayment",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderPayment",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "OrderPaymentCancelUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPaymentCancelPayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentCompletePayload",
				"fields": [
					{
						"name": "order",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Order",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "orderPayment",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderPayment",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "paymentStatus",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "OrderPaymentCompleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPaymentCompletePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentCreatePayload",
				"fields": [
					{
						"name": "order",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Order",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "orderPayment",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderPayment",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "OrderPaymentCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPaymentCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentData",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "key",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentEsto",
				"fields": [
					{
						"name": "redirectUrl",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentEvent",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "orderPayment",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderPayment",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "orderState",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "user",
						"type": {
							"kind": "OBJECT",
							"name": "User",
							"ofType": null
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "OrderEvent"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentExecutePayload",
				"fields": [
					{
						"name": "order",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Order",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "orderPayment",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderPayment",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "paymentAction",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderPaymentExecutionUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "OrderPaymentExecuteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPaymentExecutePayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "OrderPaymentExecutionUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "OrderPaymentAvarda"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPaymentAvardaEstonia"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPaymentEsto"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPaymentHolmbank"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPaymentInbank"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPaymentMaksekeskus"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPaymentMontonio"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPaymentPaytrail"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPaymentPaywerk"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentHolmbank",
				"fields": [
					{
						"name": "redirectUrl",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentInbank",
				"fields": [
					{
						"name": "purchaseId",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "redirectUrl",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "INTERFACE",
				"name": "OrderPaymentInfo",
				"fields": [
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OrderData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "method",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": [],
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "OrderPaymentInfoAvarda"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPaymentInfoAvardaEstonia"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPaymentInfoEsto"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPaymentInfoInbank"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPaymentInfoMaksekeskus"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPaymentInfoMontonio"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPaymentInfoPaytrail"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPaymentInfoPaywerk"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentInfoAvarda",
				"fields": [
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OrderData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "method",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "paymentType",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "OrderPaymentInfo"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentInfoAvardaEstonia",
				"fields": [
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OrderData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "method",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "OrderPaymentInfo"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentInfoEsto",
				"fields": [
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OrderData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "method",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "OrderPaymentInfo"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentInfoInbank",
				"fields": [
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OrderData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "method",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "OrderPaymentInfo"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentInfoMaksekeskus",
				"fields": [
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OrderData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "method",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "OrderPaymentInfo"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentInfoMontonio",
				"fields": [
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OrderData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "method",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "OrderPaymentInfo"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentInfoPaytrail",
				"fields": [
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OrderData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "method",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "OrderPaymentInfo"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentInfoPaywerk",
				"fields": [
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OrderData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "method",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "OrderPaymentInfo"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentMaksekeskus",
				"fields": [
					{
						"name": "redirectUrl",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentMontonio",
				"fields": [
					{
						"name": "redirectUrl",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentNotifyPayload",
				"fields": [
					{
						"name": "order",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Order",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "orderPayment",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderPayment",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "OrderPaymentNotifyUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPaymentNotifyPayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentPaytrail",
				"fields": [
					{
						"name": "fields",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OrderPaymentPaytrailFormField",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "formActionUrl",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentPaytrailFormField",
				"fields": [
					{
						"name": "key",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentPaywerk",
				"fields": [
					{
						"name": "paywerkId",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "OrderPaymentResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPayment"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderPaymentUpdatePayload",
				"fields": [
					{
						"name": "order",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Order",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "orderPayment",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderPayment",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "OrderPaymentUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "OrderPaymentUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderProduct",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "discounts",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OrderProductDiscount",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "order",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Order",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "originalPrice",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "originalUnitPrice",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "price",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "SimpleProduct",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "promotions",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Promotion",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "quantity",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "taxRate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "unitPrice",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderProductDiscount",
				"fields": [
					{
						"name": "amount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "promotion",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Promotion",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderProductProperty",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderReceivePayload",
				"fields": [
					{
						"name": "order",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Order",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "OrderReceiveUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "OrderReceivePayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "OrderResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "Order"
					}
				]
			},
			{
				"kind": "INTERFACE",
				"name": "OrderShippingInfo",
				"fields": [
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OrderData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "method",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "originalPrice",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "price",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "taxRate",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [],
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "OrderShippingInfoEmail"
					},
					{
						"kind": "OBJECT",
						"name": "OrderShippingInfoHakonen"
					},
					{
						"kind": "OBJECT",
						"name": "OrderShippingInfoLocalDelivery"
					},
					{
						"kind": "OBJECT",
						"name": "OrderShippingInfoMatkahuolto"
					},
					{
						"kind": "OBJECT",
						"name": "OrderShippingInfoOmniva"
					},
					{
						"kind": "OBJECT",
						"name": "OrderShippingInfoPickUpFromStore"
					},
					{
						"kind": "OBJECT",
						"name": "OrderShippingInfoPosti"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderShippingInfoEmail",
				"fields": [
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OrderData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "method",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "originalPrice",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "price",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "taxRate",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "OrderShippingInfo"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderShippingInfoHakonen",
				"fields": [
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OrderData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "method",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "originalPrice",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "price",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "taxRate",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "OrderShippingInfo"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderShippingInfoLocalDelivery",
				"fields": [
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OrderData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "method",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "originalPrice",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "price",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "taxRate",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "OrderShippingInfo"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderShippingInfoMatkahuolto",
				"fields": [
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OrderData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "method",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "office",
						"type": {
							"kind": "OBJECT",
							"name": "ShippingMethodMatkahuoltoOffice",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "originalPrice",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "price",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "taxRate",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "OrderShippingInfo"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderShippingInfoOmniva",
				"fields": [
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OrderData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "method",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "originalPrice",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "pickupPointCode",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "price",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "taxRate",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "OrderShippingInfo"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderShippingInfoPickUpFromStore",
				"fields": [
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OrderData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "method",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "originalPrice",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "outlet",
						"type": {
							"kind": "OBJECT",
							"name": "Outlet",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "price",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "taxRate",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "OrderShippingInfo"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderShippingInfoPosti",
				"fields": [
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OrderData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "method",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "originalPrice",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "price",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "taxRate",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "OrderShippingInfo"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderStateEvent",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "orderState",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "user",
						"type": {
							"kind": "OBJECT",
							"name": "User",
							"ofType": null
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "OrderEvent"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderStatistics",
				"fields": [
					{
						"name": "date",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "totalAmount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "OrderTaxLine",
				"fields": [
					{
						"name": "amount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "rate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "taxClass",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "TaxClass",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "OrderUndoFinalizePayload",
				"fields": [
					{
						"name": "order",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Order",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "OrderUndoFinalizeUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "OrderUndoFinalizePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrderUpdatePayload",
				"fields": [
					{
						"name": "order",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Order",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "OrderUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "OrderUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OrdersConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OrdersEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "OrdersEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Order",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "Outlet",
				"fields": [
					{
						"name": "address",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "city",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "location",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "number",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "pickupAvailable",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "pickupInstructions",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "postalCode",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OutletCreatePayload",
				"fields": [
					{
						"name": "outlet",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Outlet",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "OutletCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "OutletCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OutletDeletePayload",
				"fields": [
					{
						"name": "outlet",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Outlet",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "OutletDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "OutletDeletePayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "OutletResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "Outlet"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OutletUpdatePayload",
				"fields": [
					{
						"name": "outlet",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Outlet",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "OutletUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "OutletUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "OutletsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OutletsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "OutletsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Outlet",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "PageInfo",
				"fields": [
					{
						"name": "endCursor",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "hasNextPage",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "hasPreviousPage",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "startCursor",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "INTERFACE",
				"name": "PaymentMethod",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PaymentMethodData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "environment",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "group",
						"type": {
							"kind": "OBJECT",
							"name": "PaymentMethodGroup",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "logo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				],
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "PaymentMethodAvarda"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodAvardaEstonia"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodEsto"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodHolmbank"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodInbank"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodMaksekeskus"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodMontonio"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodPaytrail"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodPaywerk"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodAvarda",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PaymentMethodData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "environment",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "group",
						"type": {
							"kind": "OBJECT",
							"name": "PaymentMethodGroup",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "logo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "paymentType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "PaymentMethod"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodAvardaEstonia",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PaymentMethodData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "environment",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "group",
						"type": {
							"kind": "OBJECT",
							"name": "PaymentMethodGroup",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "logo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "PaymentMethod"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodCreatePayload",
				"fields": [
					{
						"name": "paymentMethod",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PaymentMethodCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodData",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "key",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodDeletePayload",
				"fields": [
					{
						"name": "paymentMethod",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PaymentMethodDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodDeletePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodEsto",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PaymentMethodData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "environment",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "group",
						"type": {
							"kind": "OBJECT",
							"name": "PaymentMethodGroup",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "logo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "PaymentMethod"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodGroup",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "paymentMethods",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PaymentMethod",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodGroupAddPaymentMethodsPayload",
				"fields": [
					{
						"name": "paymentMethodGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethodGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "paymentMethods",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PaymentMethod",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PaymentMethodGroupAddPaymentMethodsUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodGroupAddPaymentMethodsPayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodGroupCreatePayload",
				"fields": [
					{
						"name": "paymentMethodGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethodGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PaymentMethodGroupCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodGroupCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodGroupDeletePayload",
				"fields": [
					{
						"name": "paymentMethodGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethodGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PaymentMethodGroupDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodGroupDeletePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodGroupRemovePaymentMethodsPayload",
				"fields": [
					{
						"name": "paymentMethodGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethodGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "paymentMethods",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PaymentMethod",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PaymentMethodGroupRemovePaymentMethodsUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodGroupRemovePaymentMethodsPayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodGroupReorderPayload",
				"fields": [
					{
						"name": "paymentMethodGroups",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PaymentMethodGroup",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodGroupReorderPaymentMethodsPayload",
				"fields": [
					{
						"name": "paymentMethodGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethodGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PaymentMethodGroupReorderPaymentMethodsUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodGroupReorderPaymentMethodsPayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "PaymentMethodGroupReorderUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodGroupReorderPayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "PaymentMethodGroupResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodGroup"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodGroupUpdatePayload",
				"fields": [
					{
						"name": "paymentMethodGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethodGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PaymentMethodGroupUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodGroupUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodGroupsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PaymentMethodGroupsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodGroupsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethodGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodHolmbank",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PaymentMethodData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "environment",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "group",
						"type": {
							"kind": "OBJECT",
							"name": "PaymentMethodGroup",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "logo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "PaymentMethod"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodInbank",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PaymentMethodData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "environment",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "group",
						"type": {
							"kind": "OBJECT",
							"name": "PaymentMethodGroup",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "logo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "PaymentMethod"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodMaksekeskus",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PaymentMethodData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "environment",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "group",
						"type": {
							"kind": "OBJECT",
							"name": "PaymentMethodGroup",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "logo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "providers",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PaymentMethodMaksekeskusProvider",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "PaymentMethod"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodMaksekeskusProvider",
				"fields": [
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodMontonio",
				"fields": [
					{
						"name": "countries",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PaymentMethodData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "environment",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "group",
						"type": {
							"kind": "OBJECT",
							"name": "PaymentMethodGroup",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "logo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "providers",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PaymentMethodMontonioProvider",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "PaymentMethod"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodMontonioProvider",
				"fields": [
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodPaytrail",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PaymentMethodData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "environment",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "group",
						"type": {
							"kind": "OBJECT",
							"name": "PaymentMethodGroup",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "logo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "providers",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PaymentMethodPaytrailProvider",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "PaymentMethod"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodPaytrailProvider",
				"fields": [
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodPaywerk",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PaymentMethodData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "environment",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "group",
						"type": {
							"kind": "OBJECT",
							"name": "PaymentMethodGroup",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "logo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "PaymentMethod"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodReorderPayload",
				"fields": [
					{
						"name": "paymentMethods",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PaymentMethod",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PaymentMethodReorderUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodReorderPayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "PaymentMethodResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodAvarda"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodAvardaEstonia"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodEsto"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodHolmbank"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodInbank"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodMaksekeskus"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodMontonio"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodPaytrail"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodPaywerk"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodUpdatePayload",
				"fields": [
					{
						"name": "paymentMethod",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PaymentMethodUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "PaymentMethodUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PaymentMethodsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "PaymentMethodsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "PriceType",
				"fields": [
					{
						"name": "code",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PriceTypeCreatePayload",
				"fields": [
					{
						"name": "priceType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PriceType",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PriceTypeCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "PriceTypeCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PriceTypeDeletePayload",
				"fields": [
					{
						"name": "priceType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PriceType",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PriceTypeDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "PriceTypeDeletePayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "PriceTypeResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "PriceType"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PriceTypeUpdatePayload",
				"fields": [
					{
						"name": "priceType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PriceType",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PriceTypeUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "PriceTypeUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PriceTypesConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PriceTypesEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "PriceTypesEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PriceType",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "INTERFACE",
				"name": "Product",
				"fields": [
					{
						"name": "assets",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductAsset",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "attributes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductAttributeValue",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": [
							{
								"name": "attributeIds",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "code",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "showInProductListing",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "showInProductPage",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "brand",
						"type": {
							"kind": "OBJECT",
							"name": "Brand",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "brandLogo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "brandTitle",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "cartRecommendations",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "CartRecommendation",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "categories",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Category",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "collections",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductCollection",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "configurationErrors",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "crossellProducts",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "dimensions",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductDimensions",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "disclaimers",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductDisclaimer",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": [
							{
								"name": "isPublished",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "fetchRelations",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductRelation",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "group",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "hasCustomName",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "internalIdentifier",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "isGiftCard",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "listingImage",
						"type": {
							"kind": "OBJECT",
							"name": "ProductImage",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "mainCategory",
						"type": {
							"kind": "OBJECT",
							"name": "Category",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "matchRelations",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductRelation",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "measurementImage",
						"type": {
							"kind": "OBJECT",
							"name": "ProductAsset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "medias",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductMedia",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "parcels",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductParcel",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "productBadges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductBadge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "productClass",
						"type": {
							"kind": "OBJECT",
							"name": "ProductClass",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "properties",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductProperty",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "publishedAt",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "qaItems",
						"type": {
							"kind": "LIST",
							"ofType": {
								"kind": "NON_NULL",
								"ofType": {
									"name": "QuestionAndAnswer",
									"kind": "OBJECT",
									"ofType": null
								}
							}
						},
						"args": []
					},
					{
						"name": "relatedProducts",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "seo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductSeo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "shortDescription",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "sku",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "specification",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "upsellProducts",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				],
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "ConfigurableProduct"
					},
					{
						"kind": "OBJECT",
						"name": "SimpleProduct"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductAddCategoriesPayload",
				"fields": [
					{
						"name": "categories",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Category",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductAddCategoriesUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductAddCategoriesPayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductAsset",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isMeasurement",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "url",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductAssetCreatePayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productAsset",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductAsset",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductAssetCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductAssetCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductAssetDeletePayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productAsset",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductAsset",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductAssetDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductAssetDeletePayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "ProductAssetResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductAsset"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductAssetUpdatePayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productAsset",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductAsset",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductAssetUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductAssetUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductAssetsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductAssetsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductAssetsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductAsset",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "INTERFACE",
				"name": "ProductAttributeValue",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				],
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "ProductColorValue"
					},
					{
						"kind": "OBJECT",
						"name": "ProductDateValue"
					},
					{
						"kind": "OBJECT",
						"name": "ProductDropdownValue"
					},
					{
						"kind": "OBJECT",
						"name": "ProductMultiselectValue"
					},
					{
						"kind": "OBJECT",
						"name": "ProductNumberValue"
					},
					{
						"kind": "OBJECT",
						"name": "ProductTagsValue"
					},
					{
						"kind": "OBJECT",
						"name": "ProductTextValue"
					},
					{
						"kind": "OBJECT",
						"name": "ProductTextareaValue"
					},
					{
						"kind": "OBJECT",
						"name": "ProductToggleValue"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductBadge",
				"fields": [
					{
						"name": "backgroundColor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "icon",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "listingTitle",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "priority",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "textColor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "transparentBackground",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "url",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductBadgeConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductBadgeEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductBadgeCreatePayload",
				"fields": [
					{
						"name": "productBadge",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductBadge",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductBadgeCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductBadgeCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductBadgeDeletePayload",
				"fields": [
					{
						"name": "productBadge",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductBadge",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductBadgeDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductBadgeDeletePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductBadgeDuplicatePayload",
				"fields": [
					{
						"name": "productBadge",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductBadge",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductBadgeDuplicateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductBadgeDuplicatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductBadgeEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductBadge",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductBadgeResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductBadge"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductBadgeUpdatePayload",
				"fields": [
					{
						"name": "productBadge",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductBadge",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductBadgeUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductBadgeUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductCart",
				"fields": [
					{
						"name": "maxAmount",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "minAmount",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "multiplier",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductClass",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "productCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductClassCreatePayload",
				"fields": [
					{
						"name": "productClass",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductClass",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductClassCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductClassCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductClassDeletePayload",
				"fields": [
					{
						"name": "productClass",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductClass",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductClassDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductClassDeletePayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "ProductClassResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductClass"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductClassUpdatePayload",
				"fields": [
					{
						"name": "productClass",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductClass",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductClassUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductClassUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductClassesConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductClassesEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductClassesEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductClass",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductClearStocksPayload",
				"fields": [
					{
						"name": "message",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductClearStocksUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductClearStocksPayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductCollection",
				"fields": [
					{
						"name": "code",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "productCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductCollectionAddProductsPayload",
				"fields": [
					{
						"name": "productCollection",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductCollection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "products",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Product",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductCollectionAddProductsUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductCollectionAddProductsPayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductCollectionCreatePayload",
				"fields": [
					{
						"name": "productCollection",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductCollection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductCollectionCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductCollectionCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductCollectionDeletePayload",
				"fields": [
					{
						"name": "productCollection",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductCollection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductCollectionDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductCollectionDeletePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductCollectionDuplicatePayload",
				"fields": [
					{
						"name": "productCollection",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductCollection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductCollectionDuplicateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductCollectionDuplicatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductCollectionRemoveProductsPayload",
				"fields": [
					{
						"name": "productCollection",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductCollection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "products",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Product",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductCollectionRemoveProductsUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductCollectionRemoveProductsPayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "ProductCollectionResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductCollection"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductCollectionUpdatePayload",
				"fields": [
					{
						"name": "productCollection",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductCollection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductCollectionUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductCollectionUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductCollectionsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductCollectionsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductCollectionsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductCollection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductColorValue",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "ProductAttributeValue"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductConfigurableAttribute",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "options",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductConfigurableAttributeOption",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductConfigurableAttributeOption",
				"fields": [
					{
						"name": "option",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeOption",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "products",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "SimpleProduct",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductConfiguration",
				"fields": [
					{
						"name": "attributes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductConfigurableAttribute",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "defaultProduct",
						"type": {
							"kind": "OBJECT",
							"name": "SimpleProduct",
							"ofType": null
						},
						"args": [
							{
								"name": "compute",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "products",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "SimpleProduct",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "productsConnection",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductCreatePayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductDateValue",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "ProductAttributeValue"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductDeletePayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductDeletePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductDimensions",
				"fields": [
					{
						"name": "assemblyTime",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "depth",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "diameter",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "height",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "volume",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "weight",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "width",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductDisclaimer",
				"fields": [
					{
						"name": "backgroundColor",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "content",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "contentTitle",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "link",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "priority",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "publishedFrom",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "publishedTo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "textColor",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "titleColor",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductDisclaimerCreatePayload",
				"fields": [
					{
						"name": "productDisclaimer",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductDisclaimer",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductDisclaimerCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductDisclaimerCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductDisclaimerDeletePayload",
				"fields": [
					{
						"name": "productDisclaimer",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductDisclaimer",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductDisclaimerDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductDisclaimerDeletePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductDisclaimerDuplicatePayload",
				"fields": [
					{
						"name": "productDisclaimer",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductDisclaimer",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductDisclaimerDuplicateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductDisclaimerDuplicatePayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "ProductDisclaimerResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductDisclaimer"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductDisclaimerUpdatePayload",
				"fields": [
					{
						"name": "productDisclaimer",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductDisclaimer",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductDisclaimerUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductDisclaimerUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductDisclaimersConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductDisclaimersEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductDisclaimersEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductDisclaimer",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductDropdownValue",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "OBJECT",
							"name": "AttributeOption",
							"ofType": null
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "ProductAttributeValue"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductDuplicatePayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductDuplicateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductDuplicatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductExport",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "fields",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "filename",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "notifyToEmail",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductExportCreatePayload",
				"fields": [
					{
						"name": "productExport",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductExport",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductExportCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductExportCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductExportDeletePayload",
				"fields": [
					{
						"name": "productExport",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductExport",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductExportDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductExportDeletePayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "ProductExportResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductExport"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductExportUpdatePayload",
				"fields": [
					{
						"name": "productExport",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductExport",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductExportUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductExportUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductExportsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductExportsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductExportsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductExport",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductGroup",
				"fields": [
					{
						"name": "attributes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Attribute",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isDefault",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "productCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductGroupAddAttributesPayload",
				"fields": [
					{
						"name": "attributes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Attribute",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "productGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductGroupAddAttributesUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductGroupAddAttributesPayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductGroupCreatePayload",
				"fields": [
					{
						"name": "productGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductGroupCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductGroupCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductGroupDeletePayload",
				"fields": [
					{
						"name": "productGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductGroupDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductGroupDeletePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductGroupRemoveAttributesPayload",
				"fields": [
					{
						"name": "attributes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Attribute",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "productGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductGroupRemoveAttributesUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductGroupRemoveAttributesPayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "ProductGroupResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductGroup"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductGroupStatistics",
				"fields": [
					{
						"name": "date",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groups",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductGroupStatisticsGroup",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductGroupStatisticsGroup",
				"fields": [
					{
						"name": "productGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalAmount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductGroupUpdatePayload",
				"fields": [
					{
						"name": "productGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductGroupUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductGroupUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductGroupsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductGroupsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductGroupsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductImage",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "height",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isDefault",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "orientation",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "shotType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "url",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "width",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "ProductMedia"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductImport",
				"fields": [
					{
						"name": "columns",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductImportColumn",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": [
							{
								"name": "count",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "configuration",
						"type": {
							"kind": "LIST",
							"ofType": {
								"kind": "NON_NULL",
								"ofType": {
									"name": "ProductImportConfigurationField",
									"kind": "INTERFACE",
									"ofType": null
								}
							}
						},
						"args": []
					},
					{
						"name": "createNewProducts",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "defaultProductGroup",
						"type": {
							"kind": "OBJECT",
							"name": "ProductGroup",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "defaultTaxClass",
						"type": {
							"kind": "OBJECT",
							"name": "TaxClass",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "fieldMapping",
						"type": {
							"kind": "LIST",
							"ofType": {
								"kind": "NON_NULL",
								"ofType": {
									"name": "ProductImportMappingField",
									"kind": "INTERFACE",
									"ofType": null
								}
							}
						},
						"args": []
					},
					{
						"name": "hasHeader",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isExported",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductImportAttributeConfigurationField",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "ProductImportConfigurationField"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductImportAttributeMappingField",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "ProductImportMappingField"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductImportColumn",
				"fields": [
					{
						"name": "isHidden",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "values",
						"type": {
							"kind": "LIST",
							"ofType": {
								"kind": "NON_NULL",
								"ofType": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "INTERFACE",
				"name": "ProductImportConfigurationField",
				"fields": [
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [],
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "ProductImportAttributeConfigurationField"
					},
					{
						"kind": "OBJECT",
						"name": "ProductImportEmptyConfigurationField"
					},
					{
						"kind": "OBJECT",
						"name": "ProductImportPriceTypeConfigurationField"
					},
					{
						"kind": "OBJECT",
						"name": "ProductImportPropertyConfigurationField"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductImportCreatePayload",
				"fields": [
					{
						"name": "productImport",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductImport",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductImportCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductImportCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductImportDeletePayload",
				"fields": [
					{
						"name": "productImport",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductImport",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductImportDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductImportDeletePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductImportEmptyConfigurationField",
				"fields": [
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "ProductImportConfigurationField"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductImportEmptyMappingField",
				"fields": [
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "ProductImportMappingField"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductImportExecutePayload",
				"fields": [
					{
						"name": "productImport",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductImport",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductImportExecuteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductImportExecutePayload"
					}
				]
			},
			{
				"kind": "INTERFACE",
				"name": "ProductImportMappingField",
				"fields": [
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [],
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "ProductImportAttributeMappingField"
					},
					{
						"kind": "OBJECT",
						"name": "ProductImportEmptyMappingField"
					},
					{
						"kind": "OBJECT",
						"name": "ProductImportPriceTypeMappingField"
					},
					{
						"kind": "OBJECT",
						"name": "ProductImportPropertyMappingField"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductImportPriceTypeConfigurationField",
				"fields": [
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "priceType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PriceType",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "ProductImportConfigurationField"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductImportPriceTypeMappingField",
				"fields": [
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "priceType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PriceType",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "ProductImportMappingField"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductImportPropertyConfigurationField",
				"fields": [
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "property",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "ProductImportConfigurationField"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductImportPropertyMappingField",
				"fields": [
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "property",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "ProductImportMappingField"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "ProductImportResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductImport"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductImportUpdatePayload",
				"fields": [
					{
						"name": "productImport",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductImport",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductImportUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductImportUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductInventory",
				"fields": [
					{
						"name": "alertQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "availableFromNextShipment",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "availableQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "deliveryEstimateDays",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "expectedShipmentDate",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "isAvailableForPurchase",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isGiftCard",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "useInventoryTracking",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductMaskMedia",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "linkedOptions",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "AttributeOption",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "specifier",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "url",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductMaskMediaCreatePayload",
				"fields": [
					{
						"name": "mainProduct",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productMaskMedia",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductMaskMedia",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductMaskMediaCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductMaskMediaCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductMaskMediaDeletePayload",
				"fields": [
					{
						"name": "mainProduct",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productMaskMedia",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductMaskMedia",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductMaskMediaDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductMaskMediaDeletePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductMaskMediaUpdatePayload",
				"fields": [
					{
						"name": "mainProduct",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productMaskMedia",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductMaskMedia",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductMaskMediaUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductMaskMediaUpdatePayload"
					}
				]
			},
			{
				"kind": "INTERFACE",
				"name": "ProductMedia",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "url",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				],
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "ProductImage"
					},
					{
						"kind": "OBJECT",
						"name": "ProductModel"
					},
					{
						"kind": "OBJECT",
						"name": "ProductVideo"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductMediaCreatePayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productMedia",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductMedia",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductMediaCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductMediaCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductMediaDeletePayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productMedia",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductMedia",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductMediaDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductMediaDeletePayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "ProductMediaResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductImage"
					},
					{
						"kind": "OBJECT",
						"name": "ProductModel"
					},
					{
						"kind": "OBJECT",
						"name": "ProductVideo"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductMediaUpdatePayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productMedia",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductMedia",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductMediaUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductMediaUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductMediasConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductMediasEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductMediasEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductMedia",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductModel",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "url",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "ProductMedia"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductMultiselectValue",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "AttributeOption",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "ProductAttributeValue"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductNumberValue",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "ProductAttributeValue"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductOutlet",
				"fields": [
					{
						"name": "availableQuantity",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "modelQuantity",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "outlet",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Outlet",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductOutletStock",
				"fields": [
					{
						"name": "availableQuantity",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "modelQuantity",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "outlet",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductOutletStockOutlet",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductOutletStockOutlet",
				"fields": [
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "number",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductParcel",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "depth",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "externalId",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "height",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "number",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "productQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "quantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "tareWeight",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "volume",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "weight",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "width",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductParcelCreatePayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productParcel",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductParcel",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductParcelCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductParcelCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductParcelDeletePayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productParcel",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductParcel",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductParcelDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductParcelDeletePayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "ProductParcelResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductParcel"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductParcelUpdatePayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productParcel",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductParcel",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductParcelUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductParcelUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductParcelsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductParcelsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductParcelsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductParcel",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductPrice",
				"fields": [
					{
						"name": "date",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "price",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductPriceType",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "price",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "priceType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PriceType",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductPriceTypeCreatePayload",
				"fields": [
					{
						"name": "productPriceType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductPriceType",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductPriceTypeCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductPriceTypeCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductPriceTypeDeletePayload",
				"fields": [
					{
						"name": "productPriceType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductPriceType",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductPriceTypeDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductPriceTypeDeletePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductPriceTypeUpdatePayload",
				"fields": [
					{
						"name": "productPriceType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductPriceType",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductPriceTypeUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductPriceTypeUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductPricing",
				"fields": [
					{
						"name": "cartPromotionPrice",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "clubPrice",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "includeInPromotions",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isMarginOk",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "lowestPrice",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "originalPrice",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "price",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "priceTypes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductPriceType",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "promotionGroup",
						"type": {
							"kind": "OBJECT",
							"name": "PromotionGroup",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "promotionPrice",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "purchasePrice",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "skipMarginCalculation",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "suggestedRetailPrice",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "taxClass",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "TaxClass",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductPropertiesConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductPropertiesEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductPropertiesEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductProperty",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductProperty",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isRequired",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "options",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductPropertyOption",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductPropertyCreatePayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productProperty",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductProperty",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductPropertyCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductPropertyCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductPropertyDeletePayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productProperty",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductProperty",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductPropertyDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductPropertyDeletePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductPropertyOption",
				"fields": [
					{
						"name": "color",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "image",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductPropertyOptionCreatePayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productProperty",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductProperty",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productPropertyOption",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductPropertyOption",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductPropertyOptionCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductPropertyOptionCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductPropertyOptionDeletePayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productProperty",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductProperty",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productPropertyOption",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductPropertyOption",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductPropertyOptionDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductPropertyOptionDeletePayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "ProductPropertyOptionResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductPropertyOption"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductPropertyOptionUpdatePayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productProperty",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductProperty",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productPropertyOption",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductPropertyOption",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductPropertyOptionUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductPropertyOptionUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductPropertyOptionsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductPropertyOptionsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductPropertyOptionsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductPropertyOption",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductPropertyReorderOptionsPayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productProperty",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductProperty",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductPropertyReorderOptionsUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductPropertyReorderOptionsPayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "ProductPropertyResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductProperty"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductPropertyUpdatePayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productProperty",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductProperty",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductPropertyUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductPropertyUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductRelation",
				"fields": [
					{
						"name": "category",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "fetchRuleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "fetchType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "matchRuleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "matchType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "priority",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductRelationAddProductsPayload",
				"fields": [
					{
						"name": "productRelation",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductRelation",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "products",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Product",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductRelationAddProductsUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductRelationAddProductsPayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductRelationCreatePayload",
				"fields": [
					{
						"name": "productRelation",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductRelation",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductRelationCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductRelationCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductRelationDeletePayload",
				"fields": [
					{
						"name": "productRelation",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductRelation",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductRelationDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductRelationDeletePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductRelationRemoveProductsPayload",
				"fields": [
					{
						"name": "productRelation",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductRelation",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "products",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Product",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductRelationRemoveProductsUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductRelationRemoveProductsPayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "ProductRelationResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductRelation"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductRelationUpdatePayload",
				"fields": [
					{
						"name": "productRelation",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductRelation",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductRelationUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductRelationUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductRelationsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductRelationsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductRelationsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductRelation",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductRemoveCategoriesPayload",
				"fields": [
					{
						"name": "categories",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Category",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductRemoveCategoriesUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductRemoveCategoriesPayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductReorderAssetsPayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductReorderAssetsUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductReorderAssetsPayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductReorderMediasPayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductReorderMediasUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductReorderMediasPayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductReorderPropertiesPayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductReorderPropertiesUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductReorderPropertiesPayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "ProductResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "ConfigurableProduct"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "SimpleProduct"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductSeo",
				"fields": [
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "hasCustomSlug",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "keywords",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "slug",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductSetDefaultMediaPayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductSetDefaultMediaUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductSetDefaultMediaPayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductSetMeasurementAssetPayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductSetMeasurementAssetUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductSetMeasurementAssetPayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductTagsValue",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "ProductAttributeValue"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductTextValue",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "ProductAttributeValue"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductTextareaValue",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "ProductAttributeValue"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductToggleValue",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "ProductAttributeValue"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductUpdateAttributesPayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductUpdateAttributesUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductUpdateAttributesPayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductUpdateConfigurableDataPayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ConfigurableProduct",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductUpdateConfigurableDataUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductUpdateConfigurableDataPayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductUpdatePayload",
				"fields": [
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductValueCollection",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "productBrandImage",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "productBrandName",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "productCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductValueCollectionAddProductsPayload",
				"fields": [
					{
						"name": "productValueCollection",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductValueCollection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "products",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Product",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductValueCollectionAddProductsUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductValueCollectionAddProductsPayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductValueCollectionCreatePayload",
				"fields": [
					{
						"name": "productValueCollection",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductValueCollection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductValueCollectionCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductValueCollectionCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductValueCollectionDeletePayload",
				"fields": [
					{
						"name": "productValueCollection",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductValueCollection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductValueCollectionDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductValueCollectionDeletePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductValueCollectionRemoveProductsPayload",
				"fields": [
					{
						"name": "productValueCollection",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductValueCollection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "products",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Product",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductValueCollectionRemoveProductsUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductValueCollectionRemoveProductsPayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "ProductValueCollectionResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductValueCollection"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductValueCollectionUpdatePayload",
				"fields": [
					{
						"name": "productValueCollection",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductValueCollection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ProductValueCollectionUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ProductValueCollectionUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductValueCollectionsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductValueCollectionsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductValueCollectionsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductValueCollection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductVideo",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "url",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "ProductMedia"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ProductsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ProductsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Product",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "INTERFACE",
				"name": "Promotion",
				"fields": [
					{
						"name": "activeFrom",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "activeTo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "continueProcessing",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isSticky",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "matchRuleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "priority",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				],
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CartPromotionClubPrice"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionFixedAmountFromCart"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionFixedAmountFromProduct"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionFreeShipping"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionFreebie"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionPercent"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionProductCartPromotionPrice"
					},
					{
						"kind": "OBJECT",
						"name": "CatalogPromotionFixedAmount"
					},
					{
						"kind": "OBJECT",
						"name": "CatalogPromotionPercent"
					},
					{
						"kind": "OBJECT",
						"name": "CatalogPromotionProductPromotionPrice"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PromotionAddCodesPayload",
				"fields": [
					{
						"name": "codes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PromotionCode",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "promotion",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Promotion",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PromotionAddCodesUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "PromotionAddCodesPayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PromotionCode",
				"fields": [
					{
						"name": "code",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "orderCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "promotion",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Promotion",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PromotionCodeDeletePayload",
				"fields": [
					{
						"name": "promotionCode",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionCode",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PromotionCodeDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "PromotionCodeDeletePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PromotionCodesConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PromotionCodesEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "PromotionCodesEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionCode",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "PromotionCreatePayload",
				"fields": [
					{
						"name": "promotion",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Promotion",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PromotionCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "PromotionCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PromotionDeleteCodesPayload",
				"fields": [
					{
						"name": "codes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PromotionCode",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "promotion",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Promotion",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PromotionDeleteCodesUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "PromotionDeleteCodesPayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PromotionDeletePayload",
				"fields": [
					{
						"name": "promotion",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Promotion",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PromotionDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "PromotionDeletePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PromotionDuplicatePayload",
				"fields": [
					{
						"name": "promotion",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Promotion",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PromotionDuplicateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "PromotionDuplicatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PromotionGenerateCodesPayload",
				"fields": [
					{
						"name": "codes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PromotionCode",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "promotion",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Promotion",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PromotionGenerateCodesUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "PromotionGenerateCodesPayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PromotionGroup",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PromotionGroupCreatePayload",
				"fields": [
					{
						"name": "promotionGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PromotionGroupCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "PromotionGroupCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PromotionGroupDeletePayload",
				"fields": [
					{
						"name": "promotionGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PromotionGroupDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "PromotionGroupDeletePayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "PromotionGroupResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "PromotionGroup"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PromotionGroupUpdatePayload",
				"fields": [
					{
						"name": "promotionGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PromotionGroupUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "PromotionGroupUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PromotionGroupsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PromotionGroupsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "PromotionGroupsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PromotionResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "CartPromotionClubPrice"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionFixedAmountFromCart"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionFixedAmountFromProduct"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionFreeShipping"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionFreebie"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionPercent"
					},
					{
						"kind": "OBJECT",
						"name": "CartPromotionProductCartPromotionPrice"
					},
					{
						"kind": "OBJECT",
						"name": "CatalogPromotionFixedAmount"
					},
					{
						"kind": "OBJECT",
						"name": "CatalogPromotionPercent"
					},
					{
						"kind": "OBJECT",
						"name": "CatalogPromotionProductPromotionPrice"
					},
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PromotionStyle",
				"fields": [
					{
						"name": "altContent",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "altTheme",
						"type": {
							"kind": "OBJECT",
							"name": "PromotionStyleTheme",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "content",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "deliveryPricingInfoOverride",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isCampaignModalEnabled",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isDefault",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isTimedVisibility",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "mainTheme",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionStyleTheme",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "mirrored",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "productPage",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionStyleProductPage",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PromotionStyleColorInfo",
				"fields": [
					{
						"name": "color",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "customColor",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "PromotionStyleCreatePayload",
				"fields": [
					{
						"name": "promotionStyle",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionStyle",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PromotionStyleCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "PromotionStyleCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PromotionStyleDeletePayload",
				"fields": [
					{
						"name": "promotionStyle",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionStyle",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PromotionStyleDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "PromotionStyleDeletePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PromotionStyleDuplicatePayload",
				"fields": [
					{
						"name": "promotionStyle",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionStyle",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PromotionStyleDuplicateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "PromotionStyleDuplicatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PromotionStyleFontInfo",
				"fields": [
					{
						"name": "customSize",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "family",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "size",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "PromotionStyleProductPage",
				"fields": [
					{
						"name": "campaignModalContent",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "deliveryPricingInfoOverride",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "hidePriceHistory",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isCampaignModalEnabled",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "isTimedVisibility",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "omnibusContent",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "promotionTimerContent",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "showCountdownTextContent",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "showPromotionEndingTimer",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PromotionStyleResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "PromotionStyle"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PromotionStyleTheme",
				"fields": [
					{
						"name": "background",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionStyleColorInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "font",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionStyleFontInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "text",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionStyleColorInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "PromotionStyleUpdatePayload",
				"fields": [
					{
						"name": "promotionStyle",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionStyle",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PromotionStyleUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "PromotionStyleUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PromotionStylesConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PromotionStylesEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "PromotionStylesEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionStyle",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "PromotionUpdatePayload",
				"fields": [
					{
						"name": "promotion",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Promotion",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "PromotionUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "PromotionUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "PromotionsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PromotionsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "PromotionsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Promotion",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "Query",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "attributeGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeGroupResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "attributeGroups",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeGroupsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "attributeOption",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeOptionResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "attributeOptions",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributeOptionsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "attributes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AttributesConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "audits",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "AuditsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "brand",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "BrandResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "brands",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "BrandsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "cart",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "cartRecommendation",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartRecommendationResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "cartRecommendations",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CartRecommendationsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "categories",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CategoriesConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "category",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CategoryResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "companies",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CompaniesConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "company",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CompanyResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "companyAddress",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CompanyAddressResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "companyAddresses",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CompanyAddressesConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "currentStore",
						"type": {
							"kind": "OBJECT",
							"name": "Store",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "customer",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CustomerResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "customerAddress",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CustomerAddressResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "customerAddresses",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CustomerAddressesConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "customerStatistics",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "CustomerStatistics",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": [
							{
								"name": "range",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "customers",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "CustomersConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "defaultProductGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductGroupResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "defaultPromotionStyle",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionStyleResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "editor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "EditorResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "editorUpdates",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "EditorUpdatesConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "editors",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "EditorsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "giftCard",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "GiftCardResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "giftCards",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "GiftCardsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "me",
						"type": {
							"kind": "OBJECT",
							"name": "User",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "INTERFACE",
							"name": "Node",
							"ofType": null
						},
						"args": [
							{
								"name": "id",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "notificationTemplate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "NotificationTemplateResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "notificationTemplates",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "NotificationTemplatesConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "notifications",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "NotificationsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "order",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderEvents",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderEventsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderPayment",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrderPaymentResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orderStatistics",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "OrderStatistics",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": [
							{
								"name": "range",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "orders",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OrdersConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "outlet",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OutletResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "outlets",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "OutletsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "paymentMethod",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethodResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "paymentMethodGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethodGroupResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "paymentMethodGroups",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethodGroupsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "paymentMethods",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PaymentMethodsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "priceType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PriceTypeResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "priceTypes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PriceTypesConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "product",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productAsset",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductAssetResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productAssets",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductAssetsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "productBadge",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductBadgeResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productBadges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductBadgeConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "productClass",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductClassResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productClasses",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductClassesConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "productCollection",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductCollectionResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productCollections",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductCollectionsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "productDisclaimer",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductDisclaimerResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productDisclaimers",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductDisclaimersConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "productExport",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductExportResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productExports",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductExportsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "productGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductGroupResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productGroupStatistics",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductGroupStatistics",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": [
							{
								"name": "range",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productGroups",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductGroupsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "productImport",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductImportResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productMedia",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductMediaResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productMedias",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductMediasConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "productParcel",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductParcelResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productParcels",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductParcelsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productProperties",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductPropertiesConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "productProperty",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductPropertyResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productPropertyOption",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductPropertyOptionResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productPropertyOptions",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductPropertyOptionsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "productRelation",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductRelationResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productRelations",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductRelationsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "productValueCollection",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductValueCollectionResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "productValueCollections",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductValueCollectionsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "products",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "promotion",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "promotionCodes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionCodesConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "promotionGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionGroupResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "promotionGroups",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionGroupsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "promotionStyle",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionStyleResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "promotionStyles",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionStylesConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "promotions",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PromotionsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "role",
						"type": {
							"kind": "OBJECT",
							"name": "Role",
							"ofType": null
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "roles",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "RolesResult",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "page",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "perPage",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "RulesetResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "search",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "SearchConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "shippingArea",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingAreaResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "shippingAreas",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingAreasConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "shippingMethod",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "shippingMethodArea",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodAreaResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "shippingMethodAreas",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodAreasConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "shippingMethodGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodGroupResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "shippingMethodGroups",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodGroupsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "shippingMethodService",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodServiceResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "shippingMethodServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodServicesConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "shippingMethods",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "store",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "StoreResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "stores",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "StoresConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "taxClass",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "TaxClassResultUnion",
								"kind": "UNION",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "taxClasses",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "TaxClassesConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "orderBy",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "user",
						"type": {
							"kind": "OBJECT",
							"name": "User",
							"ofType": null
						},
						"args": [
							{
								"name": "where",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "users",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "UsersResult",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "page",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "perPage",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "QuestionAndAnswer",
				"fields": [
					{
						"name": "answer",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "question",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "Role",
				"fields": [
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "RolesResult",
				"fields": [
					{
						"name": "items",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Role",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "Ruleset",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groups",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "RulesetGroup",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetBrandRule",
				"fields": [
					{
						"name": "brands",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Brand",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "comparator",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groupSelector",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groupSelectorQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "RulesetRule"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetCartProductAttributeValueRule",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "comparator",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groupSelector",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groupSelectorQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "option",
						"type": {
							"kind": "OBJECT",
							"name": "AttributeOption",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "options",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "AttributeOption",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "RulesetRule"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetCreatePayload",
				"fields": [
					{
						"name": "ruleset",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Ruleset",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "RulesetCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetCustomerLoginStateRule",
				"fields": [
					{
						"name": "comparator",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groupSelector",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groupSelectorQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "RulesetRule"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetCustomerTypeRule",
				"fields": [
					{
						"name": "comparator",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groupSelector",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groupSelectorQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "RulesetRule"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetDeletePayload",
				"fields": [
					{
						"name": "ruleset",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Ruleset",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "RulesetDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetDeletePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetGroup",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "items",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "RulesetGroupItem",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetGroupItem",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "group",
						"type": {
							"kind": "OBJECT",
							"name": "RulesetGroup",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "rule",
						"type": {
							"kind": "INTERFACE",
							"name": "RulesetRule",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetNumericRule",
				"fields": [
					{
						"name": "comparator",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groupSelector",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groupSelectorQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "RulesetRule"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetOrderPaymentMethodRule",
				"fields": [
					{
						"name": "comparator",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groupSelector",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groupSelectorQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "paymentMethods",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PaymentMethod",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "RulesetRule"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetOrderShippingMethodRule",
				"fields": [
					{
						"name": "comparator",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groupSelector",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groupSelectorQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "shippingMethods",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethod",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "RulesetRule"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetProductAttributeValueRule",
				"fields": [
					{
						"name": "attribute",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Attribute",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "comparator",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groupSelector",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groupSelectorQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "option",
						"type": {
							"kind": "OBJECT",
							"name": "AttributeOption",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "options",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "AttributeOption",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "RulesetRule"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetProductCategoriesRule",
				"fields": [
					{
						"name": "categories",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Category",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "comparator",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groupSelector",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groupSelectorQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "RulesetRule"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetProductClassRule",
				"fields": [
					{
						"name": "comparator",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groupSelector",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groupSelectorQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "productClasses",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductClass",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "RulesetRule"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetProductCollectionsRule",
				"fields": [
					{
						"name": "collections",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductCollection",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "comparator",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groupSelector",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groupSelectorQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "RulesetRule"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetProductCreatedAtRule",
				"fields": [
					{
						"name": "comparator",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groupSelector",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groupSelectorQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "RulesetRule"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetProductGroupRule",
				"fields": [
					{
						"name": "comparator",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groupSelector",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groupSelectorQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groups",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductGroup",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "RulesetRule"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetProductIdRule",
				"fields": [
					{
						"name": "comparator",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groupSelector",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groupSelectorQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "products",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Product",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "RulesetRule"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetProductInventoryStateRule",
				"fields": [
					{
						"name": "comparator",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groupSelector",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groupSelectorQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "RulesetRule"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetProductOutletQuantityRule",
				"fields": [
					{
						"name": "comparator",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groupSelector",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groupSelectorQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "outlet",
						"type": {
							"kind": "OBJECT",
							"name": "Outlet",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "quantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "RulesetRule"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetProductPromotionGroupRule",
				"fields": [
					{
						"name": "comparator",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groupSelector",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groupSelectorQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "promotionGroups",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "PromotionGroup",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "RulesetRule"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetProductStateRule",
				"fields": [
					{
						"name": "comparator",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groupSelector",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groupSelectorQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "RulesetRule"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetProductTypeRule",
				"fields": [
					{
						"name": "comparator",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groupSelector",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groupSelectorQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "RulesetRule"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetProductValueCollectionsRule",
				"fields": [
					{
						"name": "comparator",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groupSelector",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groupSelectorQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "valueCollections",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductValueCollection",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "RulesetRule"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetRefreshPayload",
				"fields": [
					{
						"name": "ruleset",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Ruleset",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "RulesetRefreshUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetRefreshPayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "RulesetResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "Ruleset"
					}
				]
			},
			{
				"kind": "INTERFACE",
				"name": "RulesetRule",
				"fields": [
					{
						"name": "comparator",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groupSelector",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groupSelectorQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				],
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "RulesetBrandRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetCartProductAttributeValueRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetCustomerLoginStateRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetCustomerTypeRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetNumericRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetOrderPaymentMethodRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetOrderShippingMethodRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductAttributeValueRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductCategoriesRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductClassRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductCollectionsRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductCreatedAtRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductGroupRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductIdRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductInventoryStateRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductOutletQuantityRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductPromotionGroupRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductStateRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductTypeRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetProductValueCollectionsRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetShippingAddressPostCodeRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetShippingAddressShippingAreaRule"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetTextRule"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetShippingAddressPostCodeRule",
				"fields": [
					{
						"name": "comparator",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groupSelector",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groupSelectorQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "RulesetRule"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetShippingAddressShippingAreaRule",
				"fields": [
					{
						"name": "comparator",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groupSelector",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groupSelectorQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingArea",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "RulesetRule"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetTextRule",
				"fields": [
					{
						"name": "comparator",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "groupSelector",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "groupSelectorQuantity",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "subject",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "RulesetRule"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "RulesetUpdatePayload",
				"fields": [
					{
						"name": "ruleset",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Ruleset",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "RulesetUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "RulesetUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "SearchConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "SearchEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "SearchEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Node",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ShippingArea",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "postalCodes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingAreaCreatePayload",
				"fields": [
					{
						"name": "shippingArea",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingArea",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ShippingAreaCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingAreaCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingAreaDeletePayload",
				"fields": [
					{
						"name": "shippingArea",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingArea",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ShippingAreaDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingAreaDeletePayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "ShippingAreaResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingArea"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingAreaUpdatePayload",
				"fields": [
					{
						"name": "shippingArea",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingArea",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ShippingAreaUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingAreaUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingAreasConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingAreasEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ShippingAreasEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingArea",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "INTERFACE",
				"name": "ShippingMethod",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethodData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "freeShippingPrice",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "freeShippingPriceWithServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "group",
						"type": {
							"kind": "OBJECT",
							"name": "ShippingMethodGroup",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "logo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "originalPriceWithServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "postalCode",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "price",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "priceWithServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "postalCode",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "services",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethodService",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "taxClass",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "TaxClass",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				],
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "ShippingMethodEmail"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodHakonen"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodLocalDelivery"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodMatkahuolto"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodOmniva"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodPickUpFromStore"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodPosti"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodArea",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "price",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "shippingArea",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingArea",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodAreaCreatePayload",
				"fields": [
					{
						"name": "shippingMethod",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "shippingMethodArea",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodArea",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ShippingMethodAreaCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodAreaCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodAreaDeletePayload",
				"fields": [
					{
						"name": "shippingMethod",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "shippingMethodArea",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodArea",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ShippingMethodAreaDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodAreaDeletePayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "ShippingMethodAreaResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodArea"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodAreaUpdatePayload",
				"fields": [
					{
						"name": "shippingMethod",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "shippingMethodArea",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodArea",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ShippingMethodAreaUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodAreaUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodAreasConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethodAreasEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodAreasEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodArea",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodCreatePayload",
				"fields": [
					{
						"name": "shippingMethod",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ShippingMethodCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodData",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "key",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "value",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodDeletePayload",
				"fields": [
					{
						"name": "shippingMethod",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ShippingMethodDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodDeletePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodDuplicatePayload",
				"fields": [
					{
						"name": "shippingMethod",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ShippingMethodDuplicateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodDuplicatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodEmail",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethodData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "freeShippingPrice",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "freeShippingPriceWithServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "group",
						"type": {
							"kind": "OBJECT",
							"name": "ShippingMethodGroup",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "logo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "originalPriceWithServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "postalCode",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "price",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "priceWithServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "postalCode",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "services",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethodService",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "taxClass",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "TaxClass",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "ShippingMethod"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodGroup",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "shippingMethods",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethod",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodGroupAddShippingMethodsPayload",
				"fields": [
					{
						"name": "shippingMethodGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "shippingMethods",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethod",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ShippingMethodGroupAddShippingMethodsUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodGroupAddShippingMethodsPayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodGroupCreatePayload",
				"fields": [
					{
						"name": "shippingMethodGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ShippingMethodGroupCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodGroupCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodGroupDeletePayload",
				"fields": [
					{
						"name": "shippingMethodGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ShippingMethodGroupDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodGroupDeletePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodGroupRemoveShippingMethodsPayload",
				"fields": [
					{
						"name": "shippingMethodGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "shippingMethods",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethod",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ShippingMethodGroupRemoveShippingMethodsUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodGroupRemoveShippingMethodsPayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodGroupReorderPayload",
				"fields": [
					{
						"name": "shippingMethodGroups",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethodGroup",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodGroupReorderShippingMethodsPayload",
				"fields": [
					{
						"name": "shippingMethodGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ShippingMethodGroupReorderShippingMethodsUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodGroupReorderShippingMethodsPayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "ShippingMethodGroupReorderUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodGroupReorderPayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "ShippingMethodGroupResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodGroup"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodGroupUpdatePayload",
				"fields": [
					{
						"name": "shippingMethodGroup",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ShippingMethodGroupUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodGroupUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodGroupsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethodGroupsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodGroupsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodHakonen",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethodData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "freeShippingPrice",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "freeShippingPriceWithServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "group",
						"type": {
							"kind": "OBJECT",
							"name": "ShippingMethodGroup",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "logo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "originalPriceWithServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "postalCode",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "price",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "priceWithServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "postalCode",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "services",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethodService",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "taxClass",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "TaxClass",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "ShippingMethod"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodLocalDelivery",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethodData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "freeShippingPrice",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "freeShippingPriceWithServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "group",
						"type": {
							"kind": "OBJECT",
							"name": "ShippingMethodGroup",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "logo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "originalPriceWithServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "postalCode",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "price",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "priceWithServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "postalCode",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "services",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethodService",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "taxClass",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "TaxClass",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "ShippingMethod"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodMatkahuolto",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethodData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "freeShippingPrice",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "freeShippingPriceWithServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "group",
						"type": {
							"kind": "OBJECT",
							"name": "ShippingMethodGroup",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "logo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "offices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethodMatkahuoltoOffice",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": [
							{
								"name": "countryCode",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "postalCode",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "type",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "originalPriceWithServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "postalCode",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "price",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "priceWithServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "postalCode",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "services",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethodService",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "taxClass",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "TaxClass",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "ShippingMethod"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodMatkahuoltoOffice",
				"fields": [
					{
						"name": "address",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "city",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "countryCode",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "distance",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "postalCode",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodOmniva",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethodData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "freeShippingPrice",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "freeShippingPriceWithServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "group",
						"type": {
							"kind": "OBJECT",
							"name": "ShippingMethodGroup",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "locations",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethodOmnivaLocation",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": [
							{
								"name": "countryCode",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "postalCode",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "type",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "logo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "originalPriceWithServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "postalCode",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "price",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "priceWithServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "postalCode",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "services",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethodService",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "taxClass",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "TaxClass",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "ShippingMethod"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodOmnivaLocation",
				"fields": [
					{
						"name": "approximateDistance",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "notes",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "serviceHours",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodPickUpFromStore",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethodData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "freeShippingPrice",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "freeShippingPriceWithServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "group",
						"type": {
							"kind": "OBJECT",
							"name": "ShippingMethodGroup",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "logo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "originalPriceWithServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "postalCode",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "outlets",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Outlet",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "price",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "priceWithServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "postalCode",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "services",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethodService",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "taxClass",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "TaxClass",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "ShippingMethod"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodPosti",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "data",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethodData",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "freeShippingPrice",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "freeShippingPriceWithServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "group",
						"type": {
							"kind": "OBJECT",
							"name": "ShippingMethodGroup",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "logo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "originalPriceWithServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "postalCode",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "position",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "price",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "priceWithServices",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "postalCode",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "ruleset",
						"type": {
							"kind": "OBJECT",
							"name": "Ruleset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "services",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethodService",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "taxClass",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "TaxClass",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "ShippingMethod"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "ShippingMethodResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodEmail"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodHakonen"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodLocalDelivery"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodMatkahuolto"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodOmniva"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodPickUpFromStore"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodPosti"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodService",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "price",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Money",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "promotionPrice",
						"type": {
							"kind": "OBJECT",
							"name": "Money",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "sku",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodServiceCreatePayload",
				"fields": [
					{
						"name": "shippingMethod",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "shippingMethodService",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodService",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ShippingMethodServiceCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodServiceCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodServiceDeletePayload",
				"fields": [
					{
						"name": "shippingMethod",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "shippingMethodService",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodService",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ShippingMethodServiceDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodServiceDeletePayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "ShippingMethodServiceResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodService"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodServiceUpdatePayload",
				"fields": [
					{
						"name": "shippingMethod",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "shippingMethodService",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodService",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ShippingMethodServiceUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodServiceUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodServicesConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethodServicesEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodServicesEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethodService",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodUpdatePayload",
				"fields": [
					{
						"name": "shippingMethod",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "ShippingMethodUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "ShippingMethodUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodsConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethodsEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "ShippingMethodsEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ShippingMethod",
								"kind": "INTERFACE",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "SimpleProduct",
				"fields": [
					{
						"name": "assets",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductAsset",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "attributes",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductAttributeValue",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": [
							{
								"name": "attributeIds",
								"type": {
									"kind": "LIST",
									"ofType": {
										"kind": "NON_NULL",
										"ofType": {
											"kind": "SCALAR",
											"name": "Any"
										}
									}
								}
							},
							{
								"name": "code",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "showInProductListing",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "showInProductPage",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "availableShippingMethods",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ShippingMethod",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": [
							{
								"name": "postalCode",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "brand",
						"type": {
							"kind": "OBJECT",
							"name": "Brand",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "brandLogo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "brandTitle",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "cart",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductCart",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "cartPromotions",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "CartPromotion",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "cartRecommendations",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "CartRecommendation",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "categories",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "Category",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "collections",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductCollection",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "configurationErrors",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "crossellProducts",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "dimensions",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductDimensions",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "disclaimers",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductDisclaimer",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": [
							{
								"name": "isPublished",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "estimatedShippingPriceRange",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "MoneyRange",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "cache",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							},
							{
								"name": "postalCode",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "fetchRelations",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductRelation",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "group",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductGroup",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "hasAnyStock",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "hasCustomName",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "internalIdentifier",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "inventory",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductInventory",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "isEligibleForFreeShipping",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isGiftCard",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "listingImage",
						"type": {
							"kind": "OBJECT",
							"name": "ProductImage",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "mainCategory",
						"type": {
							"kind": "OBJECT",
							"name": "Category",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "matchRelations",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductRelation",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "measurementImage",
						"type": {
							"kind": "OBJECT",
							"name": "ProductAsset",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "medias",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductMedia",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "outlets",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductOutlet",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "outletsWithBundling",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductOutletStock",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "parcels",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductParcel",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "parcelsAreVisible",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "parentProduct",
						"type": {
							"kind": "OBJECT",
							"name": "ConfigurableProduct",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "priceHistory",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductPrice",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": [
							{
								"name": "range",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "pricing",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductPricing",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "productBadges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductBadge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "productClass",
						"type": {
							"kind": "OBJECT",
							"name": "ProductClass",
							"ofType": null
						},
						"args": []
					},
					{
						"name": "promotions",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "CatalogPromotion",
										"kind": "INTERFACE",
										"ofType": null
									}
								}
							}
						},
						"args": [
							{
								"name": "isActive",
								"type": {
									"kind": "NON_NULL",
									"ofType": {
										"kind": "SCALAR",
										"name": "Any"
									}
								}
							}
						]
					},
					{
						"name": "properties",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "ProductProperty",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "publishedAt",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "qaItems",
						"type": {
							"kind": "LIST",
							"ofType": {
								"kind": "NON_NULL",
								"ofType": {
									"name": "QuestionAndAnswer",
									"kind": "OBJECT",
									"ofType": null
								}
							}
						},
						"args": []
					},
					{
						"name": "relatedProducts",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "seo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductSeo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "shortDescription",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "sku",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "specification",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "upsellProducts",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "ProductsConnection",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "after",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "before",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "first",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "last",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "Product"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "Store",
				"fields": [
					{
						"name": "address",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "businessIdentityCode",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "city",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "contactEmail",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "contactName",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "countryCode",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "domain",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "logo",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "postalCode",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "timezone",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "StoreCreatePayload",
				"fields": [
					{
						"name": "store",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Store",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "StoreCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "StoreCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "StoreDeletePayload",
				"fields": [
					{
						"name": "store",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Store",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "StoreDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "StoreDeletePayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "StoreResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "Store"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "StoreUpdatePayload",
				"fields": [
					{
						"name": "store",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Store",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "StoreUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "StoreUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "StoresConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "StoresEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "StoresEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Store",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "Subscription",
				"fields": [
					{
						"name": "notificationCreated",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Notification",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "TaxClass",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "rate",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "TaxClassCreatePayload",
				"fields": [
					{
						"name": "taxClass",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "TaxClass",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "TaxClassCreateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "InvalidInputError"
					},
					{
						"kind": "OBJECT",
						"name": "TaxClassCreatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "TaxClassDeletePayload",
				"fields": [
					{
						"name": "taxClass",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "TaxClass",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "TaxClassDeleteUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "TaxClassDeletePayload"
					}
				]
			},
			{
				"kind": "UNION",
				"name": "TaxClassResultUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "TaxClass"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "TaxClassUpdatePayload",
				"fields": [
					{
						"name": "taxClass",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "TaxClass",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "UNION",
				"name": "TaxClassUpdateUnion",
				"possibleTypes": [
					{
						"kind": "OBJECT",
						"name": "EntityNotFoundError"
					},
					{
						"kind": "OBJECT",
						"name": "TaxClassUpdatePayload"
					}
				]
			},
			{
				"kind": "OBJECT",
				"name": "TaxClassesConnection",
				"fields": [
					{
						"name": "edges",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "TaxClassesEdge",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "pageInfo",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "PageInfo",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "TaxClassesEdge",
				"fields": [
					{
						"name": "cursor",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "node",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "TaxClass",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "User",
				"fields": [
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "customer",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "Customer",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					},
					{
						"name": "email",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "isSocialLogin",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "name",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "picture",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "roles",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "RolesResult",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": [
							{
								"name": "page",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "perPage",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							},
							{
								"name": "where",
								"type": {
									"kind": "SCALAR",
									"name": "Any"
								}
							}
						]
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "UserSetRolesPayload",
				"fields": [
					{
						"name": "user",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "User",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "UserUpdatePayload",
				"fields": [
					{
						"name": "user",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"name": "User",
								"kind": "OBJECT",
								"ofType": null
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "UsersResult",
				"fields": [
					{
						"name": "items",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "LIST",
								"ofType": {
									"kind": "NON_NULL",
									"ofType": {
										"name": "User",
										"kind": "OBJECT",
										"ofType": null
									}
								}
							}
						},
						"args": []
					},
					{
						"name": "totalCount",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": []
			},
			{
				"kind": "OBJECT",
				"name": "WebhookNotificationTemplate",
				"fields": [
					{
						"name": "contentType",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "createdAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "description",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "id",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "location",
						"type": {
							"kind": "SCALAR",
							"name": "Any"
						},
						"args": []
					},
					{
						"name": "state",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "title",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "type",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					},
					{
						"name": "updatedAt",
						"type": {
							"kind": "NON_NULL",
							"ofType": {
								"kind": "SCALAR",
								"name": "Any"
							}
						},
						"args": []
					}
				],
				"interfaces": [
					{
						"kind": "INTERFACE",
						"name": "Node"
					},
					{
						"kind": "INTERFACE",
						"name": "NotificationTemplate"
					}
				]
			},
			{
				"kind": "SCALAR",
				"name": "Any"
			}
		],
		"directives": []
	}
}
